import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Form } from "reactstrap";
import * as Yup from "yup";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { CardBody, Col, Container, Row } from "reactstrap";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import { useFormik } from "formik";
import { Breadcrumbs, Btn } from "../../../../AbstractElements";
import { get } from "../../../../_helper/api_helper";
import { ShowError, ShowSucess, ShowWarning, getUserRole, isAllowedURL } from "../../../../_helper/helper";
import { getFormalApiErrorMessage } from "../../../../utils/apiError";
import { loadingPanel } from "../../../../CommonComponents/CommonFunction";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "oidc-react";
import dayjs from "dayjs";
import { fetchGGTrackData } from "../../../Create Transaction/slices/ggTrackSlice";
import { createJobAnnouncement, getJobAnnouncementDetails, savedIsToasterShown, updateJobAnnouncement } from "../../../../store/jobAnnouncement/action";
import AnnouncementWorkflow from "./AnnouncementWorkflow";
import AnnouncementStatusChangeModal from "./AnnouncementStatusChangeModal";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import ComponentToPrint from "./PrintAnnoncement/ComponentToPrint";
import { getProcessesStatusList } from "../../../../store/process/actions";
import InterestSelection from "./InterestSelection";
import DocTypeModel from "./DocTypeModel";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DifferencesModal from "./DifferencesModal";

// const WhoCanApplyOptions = [
//   { name: "Open to all government of Guam employees and the public.​", value: "Open to all government of Guam employees and the public.​" },
//   { name: "Only permanent, government of Guam employee can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity for his/her employees pursuant to rule 4.101.A1", value: "Only permanent, government of Guam employee can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity for his/her employees pursuant to rule 4.101.A1" },
//   { name: "Only permanent, government of Guam employees from the department as identified in the area of consideration above can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity.", value: "Only permanent, government of Guam employees from the department as identified in the area of consideration above can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity." },
// ]
const WhoCanApplyOptions = [
  { name: "Only permanent, government of Guam employees from the department or agency as identified in the area of consideration above can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity for his/her employees pursuant to rule 4.101.A1​", value: "Only permanent, government of Guam employees from the department or agency as identified in the area of consideration above can apply. The appointing authority for the above department/ agency has identified this position as a career development opportunity for his/her employees pursuant to rule 4.101.A1.​​" },
  { name: "Open to all government of Guam employees and the public.​", value: "Open to all government of Guam employees and the public.​" },
  { name: "Only permanent, government of Guam employees.", value: "Only permanent, government of Guam employees." },
]

function JobAnnouncementNew() {
  const { userData } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const [newValues, setNewValues] = useState({});
  const [addRecordModel, setAddRecordModel] = useState(false);
  const [editRecordModel, setEditRecordModel] = useState(false);
  const [editingDocument, setEditingDocument] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [selectedPostion, setSelectedPostion] = useState("");
  const [selectedPostionNo, setSelectedPostionNo] = useState("");
  const [highlightAmendmentText, setHighlightAmendmentText] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [cancelRemarkInput, setCancelRemarkInput] = useState("");
  const [cancelRemarkError, setCancelRemarkError] = useState(false);
  const [qualificationRequirementLoading, setQualificationRequirementLoading] = useState(false);

  const currentRole = getUserRole(userData);


  // const [copyButtonShow, setCopyButtonShow] = useState(false);

  const [schema, setSchema] = useState(
    {
      gg1ControlNumberOption: Yup.string(),
      HrControl: Yup.string()
        .when('gg1ControlNumberOption', (gg1ControlNumberOption, schema) =>
          gg1ControlNumberOption[0] === 'with'
            ? schema.required("Recruitment Control No is required").trim()
            : schema
        ),
      JobProfilerId: Yup.string(),
      // Required validation disabled for the "Without Recruitment Control No" case.
      // JobProfilerId: Yup.string()
      //   .when('gg1ControlNumberOption', (gg1ControlNumberOption, schema) =>
      //     gg1ControlNumberOption[0] === 'without'
      //       ? schema.required("Job Profile is required").trim()
      //       : schema
      //   ),

      // dateClosed: Yup.string().required("Date Closed is required"),
      // datePosted: Yup.string().required("Date Posted is required"),
      status: Yup.string().required("Status is required"),
      payPlan: Yup.string().required("Pay Plan is required"),
      announcementType: Yup.string().required("Announcement Type is required"),
      payGrade: Yup.string().required("Pay Grade is required"),
      datePosted: Yup.date()
        .required('Start date is required')
        .test(
          "date-posted-after-today",
          "Date Posted must be greater than current date",
          (value) => {
            if (!value) return true;
            if (!id || id === "new") {
              return moment(value).startOf("day").isAfter(moment().startOf("day"));
            }
            return true;
          }
        )
        .nullable(),
      dateClosed: Yup.date()
        .required("Date Closed is required")
        .when('datePosted', (datePosted, schema) => {
          return datePosted
            ? schema.min(datePosted, 'Please select Date Closed Type')
            : schema;
        }),
      closeDuration: Yup.string().nullable(),
      deptNo: Yup.string()
        .when('announcementType', (announcementType, schema) => {
          return announcementType[0] == 'DEPARTMENTAL'
            ? Yup.string().required("Department is required")
            : schema;
        }),




      // requirements: Yup.object().shape({


      //   WhoCanApply: Yup.string().required("WhoCanApply is required"),
      //   QualificationRequirement: Yup.string().required("QualificationRequirement is required"),
      //   NatureofWork: Yup.string().required("NatureofWork is required"),
      //   illustrativeExofWork: Yup.string().required("illustrativeExofWork is required"),
      //   KnowledgeAbilitiesSkills: Yup.string().required("KnowledgeAbilitiesSkills is required"),
      //   MinimumEducationReq: Yup.string().required("MinimumEducationReq is required"),
      //   DocRequirement: Yup.string().required("DocRequirement is required"),
      //   SuitabilityDeterminationForm: Yup.string().required("SuitabilityDeterminationForm is required"),
      //   ProhibitionPursuant: Yup.string().required("ProhibitionPursuant is required"),
      //   // ExaminationReq: Yup.string().required("ExaminationReq is required"),
      //   InterviewProcedures: Yup.string().required("InterviewProcedures is required"),
      //   EmploymentMedicalExamination: Yup.string().required("EmploymentMedicalExamination is required"),
      //   WorkEligibility: Yup.string().required("WorkEligibility is required"),
      //   DrugScreening: Yup.string().required("DrugScreening is required"),
      //   PoliceCourtClearances: Yup.string().required("PoliceCourtClearances is required"),
      //   WhereToApply: Yup.string().required("WhereToApply is required"),
      //   ForMoreInfo: Yup.string().required("ForMoreInfo is required")
      // }),


    }
  );
  const [departmentList, setDepartmentList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [secondaryFilteredDivisions, setSecondaryFilteredDivisions] = useState([]);
  const [canRedirectBack, setCanRedirectBack] = useState(false);
  const [announcementTypeOption, setAnnouncementTypeOption] = useState(false);
  const [auditTrailData, setAuditTrailData] = useState([]);
  const [auditTrailLoading, setAuditTrailLoading] = useState(false);
  const [auditTrailModalOpen, setAuditTrailModalOpen] = useState(false);
  const [fieldHistoryModalOpen, setFieldHistoryModalOpen] = useState(false);
  const [fieldHistoryData, setFieldHistoryData] = useState([]);
  const [fieldHistoryLoading, setFieldHistoryLoading] = useState(false);
  const [historyDiffModalOpen, setHistoryDiffModalOpen] = useState(false);
  const [jobTransactionLogData, setJobTransactionLogData] = useState([]);
  const [jobTransactionLogLoading, setJobTransactionLogLoading] = useState(false);

  const hashIdentifier = window.location.hash;
  const { ANNOUNCEMENT_ID } = useParams();
  const id = hashIdentifier
    ? ANNOUNCEMENT_ID + hashIdentifier
    : ANNOUNCEMENT_ID;
  const isNewAnnouncement = String(ANNOUNCEMENT_ID ?? "").trim().toLowerCase() === "new";
  const preselectedPositionNo = useMemo(() => {
    const positionNo = new URLSearchParams(location.search).get("positionno");
    return positionNo ? String(positionNo).trim() : "";
  }, [location.search]);
  const preselectedHrControl = useMemo(() => {
    const hrControlFromQuery = new URLSearchParams(location.search).get("hrcontrol");
    const hrControlFromState =
      location?.state?.preselectedHrControl || location?.state?.dataItem?.HrControl;
    const hrControl = hrControlFromQuery || hrControlFromState;
    return hrControl ? String(hrControl).trim() : "";
  }, [location.search, location.state]);
  const preselectedJobProfilerId = useMemo(() => {
    const jobProfilerIdFromQuery = new URLSearchParams(location.search).get(
      "jobprofilerid"
    );
    const jobProfilerIdFromState =
      location?.state?.preselectedJobProfilerId ||
      location?.state?.dataItem?.JobProfilerId ||
      location?.state?.dataItem?.JobProfilerID ||
      location?.state?.dataItem?.JobProfiler_Id ||
      location?.state?.dataItem?.JobProfiler_id;
    const jobProfilerId = jobProfilerIdFromQuery || jobProfilerIdFromState;
    return jobProfilerId ? String(jobProfilerId).trim() : "";
  }, [location.search, location.state]);
  const preselectedJobProfilerName = useMemo(() => {
    const fromQuery = new URLSearchParams(location.search).get("jobprofilername");
    const fromState =
      location?.state?.preselectedJobProfilerName ||
      location?.state?.dataItem?.JobProfiler_name ||
      location?.state?.dataItem?.JobProfilerName;
    return (fromQuery || fromState) ? String(fromQuery || fromState).trim() : "";
  }, [location.search, location.state]);
  const { postingResult, jobAnnouncementDetails, posting, hasShownToaster, submitFailed, error } =
    useSelector((state) => state?.JobAnnouncementReducer);
  const DpDvOptions = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.dpdvItems
  );
  // const positionTitleOptions = useSelector(
  //   (state) => state.ggTrackSlice?.GGTrackData?.positionTitle
  // );
  const salaryItemsList = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.salaryItemsList
  );

  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [positionRequirements, setPositionRequirements] = useState([]);
  const [positionRequirementsLoading, setPositionRequirementsLoading] = useState(false);
  const { processStatusList } = useSelector((state) => state.processReducer);
  const [positionTitleOptions, setPositionTitleOptions] = useState([]);
  const [copyPositionTitleOptions, setCopyPositionTitleOptions] = useState([]);
  const [documentOptions, setDocumentOptions] = useState([]);
  const [documentSelected, setDocumentSelected] = useState([]);
  const [payPlansOptions, setPayPlansOptions] = useState([]);
  const [jobProfileOptions, setJobProfileOptions] = useState([]);
  const [jobProfileInputValue, setJobProfileInputValue] = useState("");
  const [withoutCaseJobProfileInputValue, setWithoutCaseJobProfileInputValue] = useState("");
  const [hrControlOptions, setHrControlOptions] = useState({ data: [], isLoading: false })
  const [originalHrControlValue, setOriginalHrControlValue] = useState("");

  const [announcementStatusChanged, setAnnouncementStatusChanged] = useState(false);
  const [isAmendmentToggling, setIsAmendmentToggling] = useState(false);
  const [isUpdatePostedActive, setIsUpdatePostedActive] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [jaRegistryDisabledFields, setJaRegistryDisabledFields] = useState(new Set());

  const modifiedOptions = useMemo(() => {
    return positionTitleOptions.map((option) => ({
      ...option,
      label: isChecked ? `${option.label} (S.F)` : option.label,
    }));
  }, [isChecked, positionTitleOptions]);

  const copyModifiedOptions = useMemo(() => {
    return copyPositionTitleOptions.map((option) => ({
      ...option,
      label: isChecked ? `${option.label} (S.F)` : option.label,
    }));
  }, [isChecked, copyPositionTitleOptions]);

  const normalizePositionKey = (item) =>
    String(item?.NPOSITION_NO || item?.value || item?.id || "").trim();

  const normalizeOptionKey = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const parseTagString = (value) =>
    String(value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);

  const mapCategoryTagsToOptions = (incomingTags = [], options = []) => {
    const safeTags = Array.isArray(incomingTags) ? incomingTags : [];
    const safeOptions = Array.isArray(options) ? options : [];
    const optionMap = new Map();

    safeOptions.forEach((option) => {
      const normalizedValue = normalizeOptionKey(option?.value);
      const normalizedLabel = normalizeOptionKey(option?.label);
      if (normalizedValue && !optionMap.has(normalizedValue)) {
        optionMap.set(normalizedValue, option?.value);
      }
      if (normalizedLabel && !optionMap.has(normalizedLabel)) {
        optionMap.set(normalizedLabel, option?.value);
      }
    });

    return safeTags
      .map((tag) => {
        const normalizedTag = normalizeOptionKey(tag);
        return optionMap.get(normalizedTag) || tag;
      })
      .filter(Boolean);
  };

  const normalizeIdKey = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase();
  const SPECIAL_WITHOUT_HR_CONTROL_PREFIX = "NR";

  const resolveHrControlValue = (source = {}) => {
    if (!source || typeof source !== "object") return "";
    const directValue =
      source?.HrControl ||
      source?.hrControl ||
      source?.HRControl ||
      source?.hrcontrol ||
      "";
    if (directValue) return String(directValue).trim();
    const matchedKey = Object.keys(source).find((key) => {
      const normalizedKey = String(key || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      return (
        normalizedKey === "hrcontrol" ||
        (normalizedKey.includes("hr") && normalizedKey.includes("control"))
      );
    });
    return matchedKey ? String(source?.[matchedKey] || "").trim() : "";
  };

  const getAnnouncementTypeConfigByArea = (areaOfConsideration) => {
    const normalizedArea = normalizeOptionKey(areaOfConsideration);
    const allOptions = Array.isArray(announcementTypeOption) ? announcementTypeOption : [];
    const getOptionValue = (option) => option?.value || option?.name || "";
    const findOption = (key) =>
      allOptions.find((option) => normalizeOptionKey(getOptionValue(option)) === key);

    // Field is always user-editable and shows every option; `defaultValue` is only
    // used to pre-select a value based on HR Control's area of consideration - it
    // never overrides a value the user has already picked.
    let defaultValue = "";
    if (normalizedArea.includes("department")) {
      defaultValue = getOptionValue(findOption("departmental"));
    } else if (normalizedArea.includes("government") || normalizedArea.includes("govt")) {
      defaultValue = getOptionValue(findOption("govtwide"));
    }

    return {
      options: allOptions,
      isReadOnly: false,
      defaultValue,
    };
  };

  const getHrControlJobProfilerId = (option) =>
    option?.jobProfilerId ||
    option?.JobProfilerId ||
    option?.JobProfilerID ||
    option?.JobProfiler_Id ||
    option?.JobProfiler_id ||
    "";

  const getMatchedJobProfileById = (jobProfilerId) => {
    const normalizedTarget = normalizeIdKey(jobProfilerId);
    if (!normalizedTarget) {
      return null;
    }
    return (
      jobProfileOptions.find((profile) => normalizeIdKey(profile?.id) === normalizedTarget) ||
      null
    );
  };

  const parseRequiredSkills = (requiredSkills) => {
    if (!requiredSkills) return [];
    if (Array.isArray(requiredSkills)) return requiredSkills;
    if (typeof requiredSkills === "string") {
      try {
        const parsed = JSON.parse(requiredSkills);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const formatQualificationRequirementFromSkills = (requiredSkills) => {
    const skills = parseRequiredSkills(requiredSkills);
    if (!skills.length) {
      return "";
    }

    return skills
      .map((skill) => {
        const skillName = String(skill?.name || "").trim();
        if (!skillName) {
          return "";
        }

        const yearsValue = Number(skill?.min_years);
        const hasYears = Number.isFinite(yearsValue) && yearsValue > 0;
        const yearsText = hasYears
          ? `Need ${Number.isInteger(yearsValue) ? yearsValue : yearsValue.toFixed(1)} year${yearsValue > 1 ? "s" : ""} experience in ${skillName}`
          : `Experience in ${skillName}`;

        const mandatoryText = skill?.mandatory
          ? " (Mandatory)"
          : " (Preferred)";

        return `${yearsText}${mandatoryText}`;
      })
      .filter(Boolean)
      .join("\n");
  };

  const findModifiedOptionByPositionNo = (positionNo) => {
    const normalizedPositionNo = String(positionNo || "").trim();
    if (!normalizedPositionNo) return null;
    return (
      modifiedOptions?.find(
        (item) => normalizePositionKey(item) === normalizedPositionNo
      ) || null
    );
  };

  const filteredJobProfileOptions = useMemo(() => {
    const normalizedInput = String(jobProfileInputValue || "").trim().toLowerCase();
    const enrichedOptions = (Array.isArray(jobProfileOptions) ? jobProfileOptions : []).map((option) => ({
      ...option,
      searchableName: String(option?.name || "").trim().toLowerCase(),
    }));

    if (!normalizedInput) {
      return enrichedOptions.slice(0, 100);
    }

    const startsWithMatches = [];
    const containsMatches = [];

    enrichedOptions.forEach((option) => {
      const searchableName = option?.searchableName || "";
      if (!searchableName) {
        return;
      }
      if (searchableName.startsWith(normalizedInput)) {
        startsWithMatches.push(option);
        return;
      }
      if (searchableName.includes(normalizedInput)) {
        containsMatches.push(option);
      }
    });

    return [...startsWithMatches, ...containsMatches].slice(0, 100);
  }, [jobProfileInputValue, jobProfileOptions]);

  const withoutCaseJobProfileOptions = useMemo(() => {
    const normalizedInput = String(withoutCaseJobProfileInputValue || "").trim().toLowerCase();
    const enrichedOptions = (Array.isArray(jobProfileOptions) ? jobProfileOptions : []).map((option) => ({
      ...option,
      searchableName: String(option?.name || "").trim().toLowerCase(),
    }));

    if (!normalizedInput) {
      return enrichedOptions.slice(0, 100);
    }

    return enrichedOptions
      .filter((option) => {
        const searchableName = option?.searchableName || "";
        return searchableName.startsWith(normalizedInput);
      })
      .slice(0, 100);
  }, [withoutCaseJobProfileInputValue, jobProfileOptions]);

  const handleCheckboxChange = (event) => {
    let originalString = values?.positionTitle
    if (originalString?.endsWith("(S.F)")) {
      originalString = originalString.slice(0, -"(S.F)".length).trim();
    }
    setFieldValue("positionTitle", values?.positionTitle ? event.target.checked ? `${originalString} (S.F)` : originalString : "")
    if (!event.target.checked) {
      setFieldValue("requirements.SelectiveFactor", "")
    }

    setIsChecked(event.target.checked);
  };

  const resetRecruitmentControlOptions = () => {
    setHrControlOptions({ data: [], isLoading: false });
    setQualificationRequirementLoading(false);
    setJaRegistryDisabledFields(new Set());
  };

  const emptyAnnouncementRequirements = {
    WhoCanApply: "",
    QualificationRequirement: "",
    NatureofWork: "",
    illustrativeExofWork: "",
    KnowledgeAbilitiesSkills: "",
    MinimumEducationReq: "",
    DocRequirement: "",
    SuitabilityDeterminationForm: "",
    ProhibitionPursuant: "",
    ExaminationReq: "",
    InterviewProcedures: "",
    EmploymentMedicalExamination: "",
    WorkEligibility: "",
    DrugScreening: "",
    PoliceCourtClearances: "",
    WhereToApply: "",
    ForMoreInfo: "",
    ExaminationRequirements: "",
    NecessarySpecialQualifications: "",
    SelectiveFactor: "",
  };

  const buildJaRegistryRequirements = (localReqs = {}, fallbackRequirements = null) => {
    const normalizedFallbackRequirements =
      fallbackRequirements && typeof fallbackRequirements === "object"
        ? fallbackRequirements
        : null;

    return Object.keys(emptyAnnouncementRequirements).reduce((acc, key) => {
      const rawValue = localReqs?.[key];
      const trimmedValue =
        rawValue === undefined || rawValue === null
          ? ""
          : String(rawValue).trim();

      if (trimmedValue) {
        acc[key] = trimmedValue;
        return acc;
      }

      acc[key] = normalizedFallbackRequirements
        ? String(normalizedFallbackRequirements?.[key] || "").trim()
        : "";
      return acc;
    }, {});
  };

  const applyJaRegistryRequirements = (localReqs = {}, fallbackRequirements = null) => {
    const nextRequirements = buildJaRegistryRequirements(localReqs, fallbackRequirements);
    setJaRegistryDisabledFields(
      new Set(
        Object.keys(emptyAnnouncementRequirements).filter(
          (key) => String(localReqs?.[key] || "").trim()
        )
      )
    );
    setValues((prev) => ({
      ...prev,
      requirements: {
        ...(prev?.requirements || {}),
        ...nextRequirements,
      },
    }));
  };

  const clearJaRegistryRequirements = (fallbackRequirements = null) => {
    const nextRequirements = fallbackRequirements && typeof fallbackRequirements === "object"
      ? buildJaRegistryRequirements({}, fallbackRequirements)
      : { ...emptyAnnouncementRequirements };

    setJaRegistryDisabledFields(new Set());
    setValues((prev) => ({
      ...prev,
      requirements: {
        ...(prev?.requirements || {}),
        ...nextRequirements,
      },
    }));
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => { },
    documentTitle: `Announcement-${jobAnnouncementDetails?.announcementId}-${moment().format("MM-DD-YY-HH:mm:ss")}`,
  });

  useEffect(() => {
    if (DpDvOptions?.length) {
      let Departments = [];
      let Divisions = [];
      const departmentNameByNo = new Map();
      DpDvOptions?.forEach((item) => {
        if (item?.deptDiv == "") {
          departmentNameByNo.set(item.deptNo, item.label);
        }
      });

      DpDvOptions?.map((i) => {
        if (i.deptDiv == "") {
          Departments.push({
            value: i.deptNo,
            name: i.label,
          });
        }

        if (i.deptDiv !== "") {
          const divisionCode = i?.deptDiv?.toString()?.trim();
          const departmentName = departmentNameByNo.get(i.deptNo) || i.label;
          Divisions.push({
            value: i.value,
            deptNo: i.deptNo,
            name: i.label,
            displayName: divisionCode
              ? `${departmentName} - ${divisionCode}`
              : i.label,
          });
        }
      });

      setDepartmentList(Departments);
      setDivisionList(Divisions);
    }
  }, [DpDvOptions]);


  const isJsonString = (str) => {
    try {
      return JSON.parse(str);
    } catch (e) {
      return "{}";
    }
  };
  useEffect(() => {
    if (!Object.keys(jobAnnouncementDetails).length) {
      return;
    }

    const currentPositionNo = String(jobAnnouncementDetails?.positionNo || "").trim();
    const matchedPosition = currentPositionNo
      ? findModifiedOptionByPositionNo(currentPositionNo)
      : null;
    const nextPositionTitle = (
      matchedPosition?.label ||
      jobAnnouncementDetails?.positionTitle ||
      ""
    ).trim();

    setValues((prev) => ({
      ...prev,
      positionTitle: nextPositionTitle,
      deptNo: jobAnnouncementDetails?.deptNo?.trim(),
      deptDivNo: jobAnnouncementDetails?.deptDivNo?.trim(),
      secDeptNo: jobAnnouncementDetails?.secDeptNo?.trim(),
      secDeptDivNo: jobAnnouncementDetails?.secDeptDivNo?.trim(),
      secondarykpp: jobAnnouncementDetails?.secondarykpp?.trim(),
    }));
  }, [jobAnnouncementDetails, modifiedOptions]);


  useEffect(() => {
    if (postingResult !== null && hasShownToaster === false) {
      ShowSucess(postingResult?.message, {
        position: "top-right",
      });
      dispatch(savedIsToasterShown(true));
      if (pendingStatusRef.current !== null) {
        setFieldValue("currentProcessStatus", pendingStatusRef.current);
        pendingStatusRef.current = null;
      }
      if (shouldNavigateAfterSubmitRef.current) {
        shouldNavigateAfterSubmitRef.current = false;
        navigate("/jobannouncement");
      } else if (shouldReloadAfterAmendmentSaveRef.current) {
        shouldReloadAfterAmendmentSaveRef.current = false;
        setTimeout(() => window.location.reload(), 1000);
      }
      // resetForm();
    }
  }, [postingResult, hasShownToaster]);

  useEffect(() => {
    if (submitFailed && error?.message) {
      ShowError(error.message);
    }
  }, [submitFailed, error]);

  const statusOption = [
    { name: "CLOSED", value: "CLOSED" },
    { name: "CONTINUOUS", value: "CONTINUOUS" },
  ];
  const closeDurationOptions = [
    { name: "2 Week", value: "2WEEK" },
    { name: "4 Week", value: "4WEEK" },
    { name: "6 Week", value: "6WEEK" },
    { name: "8 Week", value: "8WEEK" },
    { name: "Continuous", value: "CONTINUOUS" },
  ];
  const durationToDays = {
    "2WEEK": 14,
    "4WEEK": 28,
    "6WEEK": 42,
    "8WEEK": 56,
  };
  const durationToWeeks = {
    "2WEEK": 2,
    "4WEEK": 4,
    "6WEEK": 6,
    "8WEEK": 8,
  };
  const normalizeCloseDuration = (durationValue, statusValue) => {
    if (durationValue !== undefined && durationValue !== null && String(durationValue).trim() !== "") {
      const normalized = String(durationValue).trim().toUpperCase().replace(/\s+/g, "");
      const durationAliases = {
        "2WEEKS": "2WEEK",
        "4WEEKS": "4WEEK",
        "6WEEKS": "6WEEK",
        "8WEEKS": "8WEEK",
      };
      return durationAliases[normalized] || normalized;
    }
    return statusValue && statusValue !== null && statusValue.trim() === "CONTINUOUS" ? "CONTINUOUS" : "";
  };

  const appointmentTypeOption = [
    { name: "Probational", value: "25" },
    { name: "CLTA", value: "76" },
  ];

  let initialItem = {
    announcementId: "",
    positionNo: preselectedPositionNo || "",
    HrControl: preselectedHrControl || "",
    JobProfilerId: preselectedJobProfilerId || "",
    JobProfilerName: preselectedJobProfilerName || "",
    requirements: {
      WhoCanApply: WhoCanApplyOptions[0]?.value,//"",
      QualificationRequirement: "",
      NatureofWork: "",
      illustrativeExofWork: "",
      KnowledgeAbilitiesSkills: "",
      MinimumEducationReq: "",
      DocRequirement: "",
      SuitabilityDeterminationForm: "",
      ProhibitionPursuant: "",
      ExaminationReq: "",
      InterviewProcedures: "",
      EmploymentMedicalExamination: "",
      WorkEligibility: "",
      DrugScreening: "",
      PoliceCourtClearances: "",
      WhereToApply: "",
      ForMoreInfo: "",
      ExaminationRequirements: "",
      NecessarySpecialQualifications: "",
      SelectiveFactor: ""
    },
    datePosted: dayjs(new Date()),
    dateClosed: null,
    closeDuration: "",
    status: "CLOSED",
    announcementType: "",
    kpp: "",
    positionTitle: "",
    positionObj: { value: "", label: "" },
    grade: "",
    fromStep: "01",
    toStep: "10",
    fromSalary: "",
    toSalary: "",
    payPlan: "",
    payGrade: "",
    hourlyRate: "",
    fromHourlyRate: "",
    deptDivNo: "",
    deptDivName: "",
    deptNo: "",
    deptName: "",
    currentProcessStatus: 355,
    processId: 130,
    AnnouncementStatus: "",
    cancelationDate: "",
    AmendmentText: "",
    CancelationRemark: "",
    isSave: false,
    AppointmentTypeNOA: "",
    AppointmentTypeTitle: "",
    hashTag: "",
    categorieshashTag: "",
    testingReq: false,
    secondaryAnnouncementType: "",
    secondarykpp: "",
    secondaryPayGrade: "",
    secondaryFromStep: "01",
    secondaryToStep: "18",
    secondaryFromSalary: "",
    secondaryToSalary: "",
    secDeptDivNo: "",
    secDeptDivName: "",
    secDeptNo: "",
    secDeptName: "",
    remarks: "",
    docRequired: '',
    gg1ControlNumberOption: "with",
  };

  const checkInputValidations = () => {
    if (values?.AnnouncementStatus == "Amendment" && (values?.AmendmentText == "" || values?.AmendmentText == null || values?.AmendmentText == undefined)) {
      ShowError("Please Insert Amendment Text!")
      return false
    } else if (values?.AnnouncementStatus == "Cancel" && (values?.CancelationRemark == "" || values?.CancelationRemark == null || values?.CancelationRemark == undefined)) {
      ShowError("Please Insert Cancellation Remark!")
      return false
    } else {
      return true
    }
  }
  // submit request

  const onSubmit = async (isSave = false) => {
    // debugger
    let newPayload = { ...values }
    if (pendingStatusRef.current !== null) {
      newPayload.currentProcessStatus = pendingStatusRef.current;
    }
    // Remove question fields from payload
    delete newPayload.educationQuestions
    delete newPayload.skillQuestions
    delete newPayload.certificationQuestions
    delete newPayload.specializationQuestions
    newPayload.dateClosed = !newPayload?.dateClosed
      ? null
      : moment(newPayload?.dateClosed).format("YYYY-MM-DD")
    newPayload.datePosted = moment(newPayload?.datePosted).format("YYYY-MM-DD")
    newPayload.requirements = JSON.stringify(newPayload?.requirements)
    newPayload.HrControl = values?.HrControl
      ? String(values?.HrControl).trim()
      : originalHrControlValue
        ? String(originalHrControlValue).trim()
        : ""
    if (effectiveGg1ControlNumberOption === "without") {
      delete newPayload.JobProfilerId
    } else {
      newPayload.JobProfilerId = values?.JobProfilerId
        ? String(values?.JobProfilerId).trim()
        : null
    }
    newPayload.JobProfilerName = values?.JobProfilerName
      ? String(values?.JobProfilerName).trim()
      : ""
    // newPayload.requirements = (newPayload?.requirements)
    newPayload.deptName = values?.deptName
    newPayload.deptDivName = values?.deptDivName
    newPayload.hashTag = tags?.join(', ')
    newPayload.categorieshashTag = catTags?.join(', ')
    newPayload.testingReq = values?.testingReq ? 'Y' : 'N'
    newPayload.secDeptName = values?.secDeptName
    newPayload.secDeptDivName = values?.secDeptDivName
    newPayload.secondarykpp = values?.secondarykpp
    let updatedItem = documentSelected.filter((m) => documentOptions.map(item => item.ContentType)?.includes(m.ContentType))
    newPayload.documentReq = JSON.stringify(updatedItem)




    newPayload.selectivefactor = isChecked

    // Get supplemental requirements data from ReqCombinedTabsSimplified
    const supplementalData = reqCombinedTabsRef.current?.getTabQuestions() || {};
    const deletedIds = reqCombinedTabsRef.current?.getDeletedSupplementalIds() || [];

    if (!id || id === "new") {
      // For new cases, use all data from ReqCombinedTabsSimplified
      const allSupplementalRequirements = [];
      Object.keys(supplementalData).forEach(section => {
        supplementalData[section].forEach(question => {
          if (question.question?.trim()) {
            allSupplementalRequirements.push({
              reqType: section,
              description: question.question,
              years: 0,
              answerType: question.answerType,
              status: "Active",
              defaultWeight: question.weight || "0"
            });
          }
        });
      });
      newPayload.supplementalRequirements = allSupplementalRequirements.length > 0 ? allSupplementalRequirements : [{
        reqType: "",
        description: "",
        years: 0,
        answerType: "",
        status: "Active",
        defaultWeight: ""
      }];
    } else {
      // For update cases, include all supplemental requirements with their IDs
      const allSupplementalRequirements = [];
      Object.keys(supplementalData).forEach(section => {
        supplementalData[section].forEach(question => {
          if (question.question?.trim()) {
            allSupplementalRequirements.push({
              supplementalReqId: question.supplementalReqId || 0,
              reqType: section,
              description: question.question,
              years: 0,
              answerType: question.answerType,
              status: "Active",
              defaultWeight: question.weight || "0"
            });
          }
        });
      });
      newPayload.supplementalRequirements = allSupplementalRequirements;
      // Add deleted supplemental requirement IDs
      newPayload.supplementalDeleteIds = deletedIds;
    }
    // Get selected position data based on selectedVersion
    const selectedPosition = positionRequirements.find(p =>
      selectedVersion && p.requirementVersion.toString() === selectedVersion.replace('V', '')
    );

    // For update case, get jaId from existing positionRequest, for new case use 0
    const existingJaId = (id && id !== "new" && positionRequestRes?.length > 0)
      ? positionRequestRes[0]?.jaId || 0
      : 0;

    newPayload.positionRequest = [{
      jaId: existingJaId,
      positionId: selectedPosition?.positionId || 0,
      requirementVersion: selectedPosition?.requirementVersion || 0,
      description: "",
      status: "Active"
    }]

    if (!checkInputValidations()) {
      return false
    }
    // return false
    // if(!isSave){
    //   newPayload.currentProcessStatus = 353
    // }else{
    //   newPayload.currentProcessStatus = values?.currentProcessStatus;
    // }
    // return false
    try {
      // Validation successful, proceed with form submission
      // return false
      if (id && id !== "new") {
        // dispatch(updateJobAnnouncement({ ...newPayload, ANNOUNCEMENT_ID: values?.announcementId }));
        shouldNavigateAfterSubmitRef.current = !values?.isSave;
        dispatch(updateJobAnnouncement({ ...newPayload, ANNOUNCEMENT_ID: values?.announcementId, announcementTitle: values?.positionTitle }))
      } else {
        try {
          shouldNavigateAfterSubmitRef.current = true;
          dispatch(createJobAnnouncement(newPayload));
        } catch (error) {

        }


        // reset();
      }
    } catch (error) {
      // Validation failed, display error messages
      //   const validationErrors = {};
      //   error.inner.forEach((fieldError) => {
      //     validationErrors[fieldError.path] = fieldError.message;
      //   });
      //   setError(validationErrors);
    }
  };

  const {
    values,
    errors,
    touched,
    submitCount,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    validateForm,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });

  const filteredModifiedOptions = useMemo(() => {
    const positionNoText = String(values?.positionNo || "").trim().toLowerCase();
    if (!positionNoText) {
      return modifiedOptions;
    }
    return modifiedOptions.filter((item) =>
      normalizePositionKey(item).toLowerCase().includes(positionNoText)
    );
  }, [modifiedOptions, values?.positionNo]);

  const selectedJobProfileRecord = useMemo(() => {
    const matchedById = jobProfileOptions.find(
      (option) => normalizeIdKey(option?.id) === normalizeIdKey(values?.JobProfilerId)
    );
    if (matchedById) {
      return matchedById;
    }

    const fallbackName = String(values?.JobProfilerName || "").trim();
    if (!fallbackName) {
      return null;
    }

    return {
      id: values?.JobProfilerId || fallbackName,
      name: fallbackName,
      position_no: values?.positionNo || "",
    };
  }, [jobProfileOptions, values?.JobProfilerId, values?.JobProfilerName, values?.positionNo]);

  const jobProfileMatchedPositionOptions = useMemo(() => {
    const normalizedJobProfilePositionTitle = String(
      selectedJobProfileRecord?.position_title ||
      selectedJobProfileRecord?.PositionTitle ||
      selectedJobProfileRecord?.Position_Title ||
      ""
    ).trim().toLowerCase();
    if (!normalizedJobProfilePositionTitle) {
      return filteredModifiedOptions;
    }
    return filteredModifiedOptions.filter((item) =>
      String(item?.label || "").trim().toLowerCase().includes(normalizedJobProfilePositionTitle)
    );
  }, [filteredModifiedOptions, selectedJobProfileRecord]);

  const selectedHrControlOption = useMemo(
    () => hrControlOptions?.data?.find((option) => normalizeIdKey(option?.value) === normalizeIdKey(values?.HrControl)) || null,
    [hrControlOptions?.data, values?.HrControl]
  );
  const selectedWithoutCaseJobProfileOption = useMemo(() => {
    const matchedById = jobProfileOptions.find(
      (option) => normalizeIdKey(option?.id) === normalizeIdKey(values?.JobProfilerId)
    );
    if (matchedById) {
      return matchedById;
    }

    const fallbackName = String(values?.JobProfilerName || "").trim();
    if (!fallbackName) {
      return null;
    }

    return {
      id: values?.JobProfilerId || fallbackName,
      name: fallbackName,
      position_no: values?.positionNo || "",
    };
  }, [
    jobProfileOptions,
    values?.JobProfilerId,
    values?.JobProfilerName,
    values?.positionNo,
  ]);
  const hrControlDisplayValue =
    values?.HrControl ||
    originalHrControlValue ||
    resolveHrControlValue(jobAnnouncementDetails) ||
    "";
  const isExistingAnnouncement =
    String(ANNOUNCEMENT_ID ?? "").trim().toLowerCase() !== "new" &&
    String(ANNOUNCEMENT_ID ?? "").trim() !== "";
  const isExactNrHrControl = useMemo(() => {
    if (!isExistingAnnouncement) return false;
    const rawHrControl =
      resolveHrControlValue({ HrControl: values?.HrControl }) ||
      resolveHrControlValue(jobAnnouncementDetails);
    return String(rawHrControl)
      .trim()
      .toUpperCase()
      .startsWith(SPECIAL_WITHOUT_HR_CONTROL_PREFIX);
  }, [isExistingAnnouncement, values?.HrControl, jobAnnouncementDetails]);
  const effectiveGg1ControlNumberOption = isExactNrHrControl
    ? "without"
    : (values?.gg1ControlNumberOption || "with");
  const currentProcessStatusValue = String(values?.currentProcessStatus || "").trim();
  const jobAnnouncementQAClaim = userData?.profile?.["Job-Announcement-QA"] || userData?.profile?.JobAnnouncementQA;
  const currentProcessStatusName = processStatusList?.find(
    (s) => String(s?.id ?? s?.value ?? "").trim() === currentProcessStatusValue
  )?.statusName || "";
  const isQAStatus = currentProcessStatusName.trim().toLowerCase() == "qa" &&
    jobAnnouncementQAClaim == "YES";
  const currentProcessStatusNameLower = currentProcessStatusName.trim().toLowerCase();
  const isAgencyDirectorStatus =
    (currentProcessStatusNameLower == "appointing authority" ||
      currentProcessStatusNameLower == "posted") &&
    currentRole == "AGENCY-DIRECTOR";
  const isSupervisorRoleStatus =
    currentProcessStatusNameLower == "supervisor" &&
    currentRole == "SUPERVISOR";
  const canEditByStatusAndRole =
    (currentProcessStatusNameLower == "draft" ||
      currentProcessStatusNameLower == "submitted") &&
    currentRole == "HR-Recruitment";
  const isUpdatePostedQAOverride =
    isUpdatePostedActive && jobAnnouncementQAClaim == "YES";
  const isAmendmentModeActive =
    announcementStatusChanged && values?.AnnouncementStatus == "Amendment";
  const isFormForceDisabled = isUpdatePostedQAOverride || isAmendmentModeActive
    ? false
    : (!canEditByStatusAndRole && !isQAStatus || isAgencyDirectorStatus);

  const primaryAnnouncementTypeConfig = useMemo(
    () => getAnnouncementTypeConfigByArea(selectedHrControlOption?.areaOfConsideration),
    [selectedHrControlOption?.areaOfConsideration, announcementTypeOption]
  );

  const secondaryAnnouncementTypeConfig = useMemo(
    () => getAnnouncementTypeConfigByArea(selectedHrControlOption?.areaOfConsideration),
    [selectedHrControlOption?.areaOfConsideration, announcementTypeOption]
  );

  useEffect(() => {
    if (salaryItemsList?.length == 0) {
      dispatch(fetchGGTrackData(""));
    } else {
      // debugger
      let updatesGrade = values?.payGrade || values?.grade
      if (values?.grade != "" || values?.payGrade != "") {
        let salaryItem = salaryItemsList.find((item) => item?.grade?.trim() == values?.payGrade?.trim() && item?.step == "01")
        // setValues({ ...values, salary: salaryItem?.nSalary, hourlyRate: salaryItem?.nrate, fromSalary: salaryItem?.nSalary })
        setValues((states) => { return { ...states, hourlyRate: salaryItem?.nrate, fromSalary: salaryItem?.nSalary } })
      }
      // if(updatesGrade != "" && values?.fromStep != ""){
      //   let salaryItem = salaryItemsList.find((item) => item?.grade?.trim() == updatesGrade?.trim() && item?.step == values?.fromStep)
      //   setValues((states) => { return { ...states, hourlyRate: salaryItem?.nrate, fromSalary: salaryItem?.nSalary } })
      // }
      // if (updatesGrade != "" && values?.toStep != "") {
      //   let salaryItem = salaryItemsList.find((item) => item?.grade?.trim() == updatesGrade?.trim() && item?.step == values?.toStep)
      //   setValues((states) => { return { ...states, toSalary: salaryItem?.nSalary, hourlyRate: salaryItem?.nrate } })
      // }

      //update both salary at same time 

      if (updatesGrade != "" && (values?.fromStep != "" || values?.toStep != "")) {
        const fromSalaryItem = values?.fromStep != ""
          ? salaryItemsList.find(
            (item) => item?.grade?.trim() === updatesGrade?.trim() && item?.step === values?.fromStep
          )
          : null;
        const toSalaryItem = values?.toStep != ""
          ? salaryItemsList.find(
            (item) => item?.grade?.trim() === updatesGrade?.trim() && item?.step === values?.toStep
          )
          : null;

        setValues((prev) => {
          const next = { ...prev };
          if (fromSalaryItem) {
            next.hourlyRate = fromSalaryItem?.nrate;
            next.fromSalary = fromSalaryItem?.nSalary;
            next.fromHourlyRate = fromSalaryItem?.nrate;
          }
          if (toSalaryItem) {
            next.hourlyRate = toSalaryItem?.nrate;
            next.toSalary = toSalaryItem?.nSalary;
          }
          return next;
        });
      }


      let salaryItemsListNew = salaryItemsList && salaryItemsList?.length && salaryItemsList.map((item) => {
        return item.grade;
      });
      let PayGradeData1 =
        salaryItemsListNew.filter(
          (item, index) => salaryItemsListNew.indexOf(item) === index
        ) || [];
      //   setPayGradeData(PayGradeData1)  
    }

  }, [values?.grade, salaryItemsList, values?.toStep, values?.payGrade]);

  const datePostedWarningShownRef = useRef(0);
  const pendingStatusRef = useRef(null);
  const shouldNavigateAfterSubmitRef = useRef(false);
  const shouldReloadAfterAmendmentSaveRef = useRef(false);
  const preAmendmentValuesRef = useRef(null);
  const generateAnnouncementRequestIdRef = useRef(0);
  const skipDateClosedRecalcRef = useRef(false);

  useEffect(() => {
    if (salaryItemsList?.length == 0) {
      dispatch(fetchGGTrackData(""));
    } else {
      if (values?.secondaryPayGrade != "") {
        if (values?.secondaryFromStep != "") {
          let salaryItem = salaryItemsList.find((item) => item?.grade?.trim() == values?.secondaryPayGrade?.trim() && item?.step == values?.secondaryFromStep)
          setFieldValue("secondaryFromSalary", salaryItem?.nSalary)
        }
        if (values?.secondaryToStep != "") {
          let salaryItem = salaryItemsList.find((item) => item?.grade?.trim() == values?.secondaryPayGrade?.trim() && item?.step == values?.secondaryToStep)
          setFieldValue("secondaryToSalary", salaryItem?.nSalary)
        }
      }
    }
  }, [salaryItemsList, values?.secondaryPayGrade, values?.secondaryToStep, values?.secondaryFromStep])
  useEffect(() => {
    if (values?.HrControl && values?.positionNo && !hrControlOptions.data.length) {
      getHrControlOptions(values.positionNo);
    }
  }, [values?.HrControl, values?.positionNo])

  useEffect(() => {
    if (values?.HrControl && values?.positionNo && !hrControlOptions.data.length) {
      getHrControlOptions(values.positionNo);
    }
  }, [values?.HrControl, values?.positionNo])

  useEffect(() => {
    // if (
    //     jobAnnouncementDetails !== undefined &&
    //     Object.keys(jobAnnouncementDetails).length > 0
    //   ) {
    //     let newDivisions = divisionList.filter(
    //         (item) => item?.deptNo == values?.deptNo
    //       );
    //       setFilteredDivisions(newDivisions);
    //   }
    if (divisionList?.length) {
      let newDivisions = divisionList.filter(
        (item) => item?.deptNo == values?.deptNo
      );
      let secondaryDivisions = divisionList.filter(
        (item) => item?.deptNo == values?.secDeptNo
      );
      setFilteredDivisions(newDivisions);
      setSecondaryFilteredDivisions(secondaryDivisions);
    }
  }, [divisionList, values?.deptNo, values?.secDeptNo]);

  useEffect(() => {
    //GET DETAILS OF POSITION IF ID IS AVAIALBE IN URL
    if (id != null && id != "new") {
      dispatch(getJobAnnouncementDetails(id));
    }
  }, [id]);


  useEffect(() => {
    if (
      jobAnnouncementDetails !== undefined &&
      Object.keys(jobAnnouncementDetails).length > 0
    ) {
      setOriginalHrControlValue(resolveHrControlValue(jobAnnouncementDetails));
      const {
        announcementId,
        announcementType,
        dateClosed,
        datePosted,
        closeDuration,
        positionNo,
        positionTitle,
        requirements,
        status,
        deptNo,
        deptName,
        deptDivName,
        deptDivNo,
        currentProcessStatus,
        announcementStatus,
        amendmentText,
        cancellationDate,
        amendmentDate,
        closeDate,
        cancelationRemark,
        appointmentTypeNoa,
        appointmentTypeTitle,
        hashTag,
        categorieshashTag,
        testingReq,
        grade,
        payGrade,
        step,
        fromStep,
        salary,
        fromSalary,
        secondaryAnnouncementType,
        secondaryFromStep,
        secondaryFromSalary,
        secondaryToStep,
        secondaryToSalary,
        secondaryPayGrade,
        secDeptNo,
        secDeptName,
        secDeptDivName,
        secDeptDivNo,
        selectivefactor,
        remarks,
        secondarykpp,
        documentReq,
        positionRequest,
        supplementalRequirements
      } = jobAnnouncementDetails;
      const resolvedCategoriesHashTag =
        categorieshashTag || jobAnnouncementDetails?.categoriesHashTag || "";
      const parsedRequirements =
        requirements && requirements !== null ? isJsonString(requirements) : {};
      const mergedRequirements = {
        ...initialItem.requirements,
        ...(parsedRequirements && typeof parsedRequirements === "object"
          ? parsedRequirements
          : {}),
      };

      // Store positionRequestRes in state
      if (positionRequest) {
        setPositionRequestRes(positionRequest);
      }

      // Store supplementalRequirements and auto-show modal if data exists
      if (supplementalRequirements && supplementalRequirements.length > 0) {
        setSupplementalRequirementsData(supplementalRequirements);
        setShowSupplementModal(true);
      }


      setDocumentSelected(documentReq ? isJsonString(documentReq) : []);
      setIsChecked(selectivefactor)
      skipDateClosedRecalcRef.current = true;
      setValues({
        ...jobAnnouncementDetails,
        announcementId:
          announcementId && announcementId !== null && announcementId.trim(),
        deptNo: deptNo?.trim(),
        deptName: deptName,
        deptDivName: deptDivName,
        deptDivNo: deptDivNo?.trim(),
        remarks,
        announcementType:
          announcementType &&
          announcementType !== null &&
          announcementType.trim(),
        positionNo: positionNo && positionNo !== null && positionNo.trim(),
        HrControl:
          jobAnnouncementDetails?.HrControl ||
          jobAnnouncementDetails?.hrControl ||
          "",
        JobProfilerId:
          jobAnnouncementDetails?.JobProfilerId ||
          jobAnnouncementDetails?.jobProfilerId ||
          jobAnnouncementDetails?.JobProfilerID ||
          "",
        JobProfilerName:
          jobAnnouncementDetails?.JobProfilerName ||
          jobAnnouncementDetails?.jobProfilerName ||
          jobAnnouncementDetails?.JobProfiler_name ||
          "",
        positionTitle: positionTitle && positionTitle != null && positionTitle.trim(),
        positionObj: { value: positionNo && positionNo !== null && positionNo.trim(), label: positionTitle && positionTitle != null && positionTitle.trim() },
        requirements: mergedRequirements,
        status: status && status !== null && status.trim() || "CONTINUOUS",
        dateClosed: dateClosed && dateClosed !== null && dateClosed,
        datePosted: datePosted && datePosted !== null && datePosted,
        closeDuration: normalizeCloseDuration(closeDuration, status),
        currentProcessStatus: currentProcessStatus && currentProcessStatus !== null ? currentProcessStatus : 355,
        AnnouncementStatus: announcementStatus && announcementStatus !== null && announcementStatus,
        AmendmentText: amendmentText && amendmentText !== null && amendmentText,
        AmendmentDate: amendmentDate,
        cancelationDate: cancellationDate,
        closeDate: closeDate,
        AppointmentTypeNOA: appointmentTypeNoa,
        AppointmentTypeTitle: appointmentTypeTitle,
        hashTag: hashTag || "",
        categorieshashTag: resolvedCategoriesHashTag,
        testingReq: testingReq == 'Y' ? true : false,

        CancelationRemark: cancelationRemark && cancelationRemark !== null && cancelationRemark,
        grade: grade || payGrade || "",
        payGrade: payGrade || grade || "",
        fromStep: fromStep || step || "",
        fromSalary: fromSalary || salary || "",
        toStep: jobAnnouncementDetails?.toStep || "",
        toSalary: jobAnnouncementDetails?.toSalary || "",
        hourlyRate:
          jobAnnouncementDetails?.hourlyRate ||
          jobAnnouncementDetails?.Hourly_Rate ||
          "",
        fromHourlyRate: jobAnnouncementDetails?.fromHourlyRate || "",
        secondaryAnnouncementType: secondaryAnnouncementType || "",
        secondaryFromStep: secondaryFromStep || "",
        secondaryFromSalary: secondaryFromSalary || "",
        secondaryToStep: secondaryToStep || "",
        secondaryToSalary: secondaryToSalary || "",
        secondaryPayGrade: secondaryPayGrade || "",
        secDeptNo: secDeptNo?.trim(),
        secDeptName: secDeptName,
        secDeptDivName: secDeptDivName,
        secDeptDivNo: secDeptDivNo?.trim(),
        secondarykpp: secondarykpp?.trim(),
        gg1ControlNumberOption: jobAnnouncementDetails?.gg1ControlNumberOption || "with",
      });
      if (hashTag && hashTag != null) {
        setTags(parseTagString(hashTag))
      } else {
        setTags([])
      }
      if (resolvedCategoriesHashTag) {
        const parsedCategories = parseTagString(resolvedCategoriesHashTag);
        setCatTags(mapCategoryTagsToOptions(parsedCategories, jobOptionsCatList))
      } else {
        setCatTags([])
      }
    }
  }, [jobAnnouncementDetails]);

  const getDocumentList = async () => {
    try {
      axios
        .post(
          // `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global?pageNumber=1&pageSize=100000`,
          `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=100000`,
          {
            tableName: "Anouncement_Doc_Attachments",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1000000,
            sortData: "",
            additionalWhere: "Usage_Status = 'Active'",
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setDocumentOptions(response?.data?.results?.map((l) => { return { id: l.ID, ContentType: l.DocType, Description: l.Descr, Category: l.Category, CreatedDate: l.CreatedDate, CreatedBY: l.CreatedBY } }))
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
          ShowError(getFormalApiErrorMessage(error));
        });
    } catch (err) {
      // setPositionTitleOptions({ data: [], isLoading: false });
    }
  };

  const getJobPositions = async () => {
    try {
      axios
        .post(
          // `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global?pageNumber=1&pageSize=100000`,
          `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=100000`,
          {
            // tableName: "positions_job",
            tableName: "vw_job_interest",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1000000,
            sortData: "",
            additionalWhere: "",
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          // setPositionTitleOptions({ data: response.data.results, isLoading: false });
          setPositionTitleOptions(response?.data?.results);
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
          ShowError(getFormalApiErrorMessage(error));
        });
    } catch (err) {
      setPositionTitleOptions({ data: [], isLoading: false });
    }
  };

  const getCopyJobPositions = async () => {
    try {
      axios
        .post(
          `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=100000`,
          {
            tableName: "jobpostions_interest",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1000000,
            sortData: "",
            additionalWhere: "",
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setCopyPositionTitleOptions(response?.data?.results || []);
        })
        .catch((error) => {
          console.warn("Cannot retrieve copy position title data", error);
          ShowError(getFormalApiErrorMessage(error));
        });
    } catch (err) {
      setCopyPositionTitleOptions([]);
    }
  };

  const getPayPlans = async () => {
    try {
      axios
        .post(
          // `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global?pageNumber=1&pageSize=100000`,
          `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global?pageNumber=1&pageSize=100000`,
          {
            tableName: "Pay_Plan",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1000000,
            sortData: "",
            additionalWhere: "",
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          // setPositionTitleOptions({ data: response.data.results, isLoading: false });
          setPayPlansOptions(response?.data?.results?.map((item) => item.PlanName?.trim()));
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
          ShowError(getFormalApiErrorMessage(error));
        });
    } catch (err) {
      setPayPlansOptions({ data: [], isLoading: false });
    }
  };

  const getHrControlOptions = async (positionNo) => {
    setHrControlOptions({ data: [], isLoading: true });
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global`,
        {
          tableName: "fn_GetGG1RecruitmentJobprofilelist",
          searchParams: `[]`,
          // searchParams: `[{"columnName":"PositionNo","value":"${positionNo ?? ""}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
          columns: "*",
          pageNumber: 1,
          pageSize: 10000000,
          orderBy: 1,
          sortBy: "asc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
            Role: currentRole,
          },
        }
      );
      const results = response.data?.results || [];

      setHrControlOptions({
        data: results.map((item) => ({
          label: item.HrControl,
          value: item.HrControl,
          jobProfilerId:
            item?.JobProfilerId ||
            item?.JobProfilerID ||
            item?.JobProfiler_Id ||
            item?.JobProfiler_id ||
            "",
          areaOfConsideration:
            item?.AreaOfConsidration ||
            item?.AreaOfConsideration ||
            item?.areaOfConsidration ||
            item?.areaOfConsideration ||
            "",
          toPositionTitle:
            item?.ToPositionTitle ||
            item?.TO_POSITION_TITLE ||
            item?.toPositionTitle ||
            "",
          toPostTitleNo:
            item?.TO_POST_TITLE_NO ||
            item?.ToPostTitleNo ||
            item?.toPostTitleNo ||
            "",
          toPayGrade:
            item?.TO_PAY_GRADE ||
            item?.ToPayGrade ||
            item?.toPayGrade ||
            "",
          toStep:
            item?.TO_STEP ||
            item?.ToStep ||
            item?.toStep ||
            "",
          toDeptKey:
            item?.To_Dept_key ||
            item?.TO_DEPT_KEY ||
            item?.toDeptKey ||
            "",
          toDepartment:
            item?.To_Department ||
            item?.TO_DEPARTMENT ||
            item?.toDepartment ||
            "",
          toDivisionName:
            item?.ToDivisionName ||
            item?.TO_DIVISION_NAME ||
            item?.toDivisionName ||
            "",
          payPlan:
            item?.Pay_Plan ||
            item?.PayPlan ||
            item?.payPlan ||
            item?.PAY_PLAN ||
            "",
        })),
        isLoading: false,
      });
    } catch (err) {
      console.warn("Cannot retrieve HR control options", err);
      ShowError(getFormalApiErrorMessage(err));
      setHrControlOptions({ data: [], isLoading: false });
    }
  };

  const getJobProfiles = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global`,
        { tableName: "job-profiles", SearchParams: "", columns: "*", pageNumber: 1, pageSize: 10000000, orderBy: 1, sortBy: "asc", orderByMultiple: "", limit: 10000000000, sortData: "", additionalWhere: "" },
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`, Role: currentRole } }
      )
      .then((res) => setJobProfileOptions(res.data?.results || []))
      .catch((err) => {
        console.warn("Cannot retrieve job profiles", err);
        ShowError(getFormalApiErrorMessage(err));
      });
  };

  useEffect(() => {
    getJobPositions();
    getCopyJobPositions();
    getPayPlans();
    getDocumentList();
    getJobProfiles();
  }, [])

  const handleBack = () => {
    navigate(-1);
  };

  const calculateDateClosed = async (startDateValue, durationValue) => {
    if (!startDateValue || !durationValue) {
      return;
    }
    const days = durationToDays[durationValue];
    const weeks = durationToWeeks[durationValue];
    const applyLocalFallback = () => {
      if (!days) return;
      setFieldValue("status", "CLOSED");
      const closedDate = moment(startDateValue).add(days, "days");
      setFieldValue("dateClosed", closedDate.format("MM/DD/YYYY"));
    };

    if (durationValue === "CONTINUOUS") {
      setFieldValue("status", "CONTINUOUS");
      setFieldValue("dateClosed", moment(startDateValue || new Date()).add(1, "year").format("MM/DD/YYYY"));
      return;
    }
    try {
      if (!weeks) {
        applyLocalFallback();
        return;
      }
      const query = new URLSearchParams({
        startDate: moment(startDateValue).format("MM/DD/YYYY"),
        weeks: String(weeks),
      }).toString();

      const response = await get(
        `${process.env.REACT_APP_API_DOTNET_URL}/LeaveApplications/calculatedateExcludeholidays?${query}`
      );

      const calculatedDate =
        (typeof response === "string" ? response : null) ||
        response?.calculateDate ||
        response?.dateClosed ||
        response?.DateClosed ||
        response?.data?.calculateDate ||
        response?.data?.dateClosed;

      if (!calculatedDate) {
        applyLocalFallback();
        return;
      }

      setFieldValue("status", "CLOSED");
      setFieldValue("dateClosed", moment(calculatedDate).format("MM/DD/YYYY"));
    } catch (error) {
      console.warn("Error while calculating date closed", error?.message);
      applyLocalFallback();
    }
  };

  useEffect(() => {
    if (skipDateClosedRecalcRef.current) {
      skipDateClosedRecalcRef.current = false;
      return;
    }
    if (values?.closeDuration && values?.datePosted) {
      calculateDateClosed(values?.datePosted, values?.closeDuration);
    }
  }, [values?.closeDuration, values?.datePosted]);

  useEffect(() => {
    const fetchJobAnnouncementRequirements = async () => {
      if (!values.positionNo) {
        setFieldValue('educationQuestions', []);
        setFieldValue('skillQuestions', []);
        setFieldValue('certificationQuestions', []);
        setFieldValue('specializationQuestions', []);
        return;
      }
      if (values.positionNo) {
        setPositionRequirementsLoading(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_DOTNET_URL}/Job_ANNOUNCEMENT/${values.positionNo}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
              },
            }
          );
          if (!response.data || response.data.length === 0) {
            setFieldValue('educationQuestions', []);
            setFieldValue('skillQuestions', []);
            setFieldValue('certificationQuestions', []);
            setFieldValue('specializationQuestions', []);
            setPositionRequirements([]);
            setSelectedVersion('');
            if (!ANNOUNCEMENT_ID || ANNOUNCEMENT_ID === "new") {
              setValues(prev => ({
                ...prev,
                requirements: {
                  ...prev.requirements,
                  QualificationRequirement: "",
                  NatureofWork: "",
                  illustrativeExofWork: "",
                  KnowledgeAbilitiesSkills: "",
                  NecessarySpecialQualifications: "",
                  MinimumEducationReq: "",
                },
              }));
            }
          } else {
            setPositionRequirements(response.data);
          }
        } catch (error) {
          console.error('Error fetching job announcement requirements:', error);
          setFieldValue('educationQuestions', []);
          setFieldValue('skillQuestions', []);
          setFieldValue('certificationQuestions', []);
          setFieldValue('specializationQuestions', []);
          setPositionRequirements([]);
          setSelectedVersion('');
          if (!ANNOUNCEMENT_ID || ANNOUNCEMENT_ID === "new") {
            setValues(prev => ({
              ...prev,
              requirements: {
                ...prev.requirements,
                QualificationRequirement: "",
                NatureofWork: "",
                illustrativeExofWork: "",
                KnowledgeAbilitiesSkills: "",
                NecessarySpecialQualifications: "",
                MinimumEducationReq: "",
              },
            }));
          }
        } finally {
          setPositionRequirementsLoading(false);
        }
      }
    };

    fetchJobAnnouncementRequirements();
  }, [values.positionNo]);

  function renderTextInput(
    stateName,
    label,
    // disabled = false,
    multiline = false,
    disabled = false,
    required = false,
    shrink = true,
    highlight = false,

  ) {
    return (
      <TextField
        fullWidth
        size="small"
        className={highlight ? 'highlighted-input' : ''}
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false, }}
        shrink={shrink ? shrink : false}
        InputProps={{ disabled: disabled }}
        // error={!isDisableField(stateName) && errors[stateName]}
        // helperText={
        //   !required && !isDisableField(stateName) && errors[stateName]
        // }
        onChange={(e) => {
          // debugger
          handleChange(e);
          if (stateName == "toStep" || stateName == "secondaryFromStep" || stateName == "secondaryToStep") {
            if (parseInt(e.target.value) > 0) {
              if (parseInt(e.target.value) < 10) {
                setFieldValue(stateName, `0${parseInt(e.target.value)}`);
              } else {
                let b = parseInt(e.target.value, 10).toString();
                if (b?.length <= 2) {
                  setFieldValue(stateName, b);
                }
              }
            }
          }
          if (stateName === "toStep" && parseInt(e.target.value) === 10) {
            setFieldValue("secondaryToStep", "18");
          }
        }
        }
        onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        // disabled={disabled}
        required={required}
      />
    );
  }
  function renderTextArea(
    stateName,
    label,
    // disabled = false,
    multiline = false,
    required = false,
    readOnly = false,
    shrink = true,

  ) {
    const qaAlwaysReadOnlyFields = new Set([
      "QualificationRequirement",
      "NecessarySpecialQualifications",
      "NatureofWork",
      "illustrativeExofWork",
      "KnowledgeAbilitiesSkills",
    ]);
    const alwaysReadOnlyRequirementFields = isQAStatus
      ? qaAlwaysReadOnlyFields
      : new Set([
        "QualificationRequirement",
        "NecessarySpecialQualifications",
        "NatureofWork",
        "illustrativeExofWork",
        "KnowledgeAbilitiesSkills",
        "MinimumEducationReq",
        "ExaminationReq",
        "WhereToApply",
      ]);
    const isQualificationFieldLoading =
      stateName === "QualificationRequirement" && qualificationRequirementLoading;
    const isAlwaysReadOnlyRequirementField =
      alwaysReadOnlyRequirementFields.has(stateName) && !isAmendmentModeActive;
    const isReadOnly = readOnly || isAlwaysReadOnlyRequirementField;
    const isDisabled = isQualificationFieldLoading;
    const isHighlightedAmendmentText =
      stateName === "AmendmentText" &&
      (highlightAmendmentText || values?.AnnouncementStatus === "Amendment");
    const showGreyBackground = (isReadOnly || isDisabled) && !isHighlightedAmendmentText;
    const fieldError = stateName == "AmendmentText" ? !isDisabled && touched[stateName] && errors[stateName]
      :
      errors.requirements?.[stateName] && errors['requirements'][stateName] ? true : false;
    const fieldHelperText = isQualificationFieldLoading
      ? "Loading Qualification Requirements..."
      : stateName == "AmendmentText"
        ? !required && !isDisabled && touched[stateName] && errors[stateName]
        : !isDisabled && errors.requirements?.[stateName] && errors['requirements'][stateName];

    return (
      <TextField
        fullWidth
        size="small"
        className={isHighlightedAmendmentText ? 'highlighted-input' : ''}
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
            // height: "30px", // to prevent scrolling set fix height
          },
          readOnly: isReadOnly,
        }}
        sx={showGreyBackground ? {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#f2f2f2",
          },
        } : undefined}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName == "AmendmentText" ? stateName : `requirements.${stateName}`}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={stateName == "AmendmentText" ? values[stateName] : values?.["requirements"]?.[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        // error={!isDisableField(stateName) && errors[stateName]}
        // helperText={
        //   !required && !isDisableField(stateName) && errors[stateName]
        // }
        onChange={handleChange}
        onBlur={handleBlur}
        error={fieldError}
        helperText={fieldHelperText}
        disabled={isDisabled}
        required={required}
      />
    );
  }


  function renderDateInput(
    stateName,
    label,
    required = true,
    minDate = null,
    maxDate = null,

    disabled = false,
    // maxDate
    hideError = false
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          value={values[stateName]}

          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              margin="dense"
              size="small"

              helperText={hideError ? "" : errors[stateName]}
              error={hideError ? false : !!errors[stateName]}
              InputLabelProps={{ shrink: true }}

            //   error={!isDisableField(stateName) && errors[stateName]}
            // helperText={!isDisableField(stateName) && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }


  function renderDropDown(stateName, label, value, multiline = false, disabled = false) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{
            width: "100%",
            // backgroundColor: (!isDisableField(stateName) && actBg) || "",
          }}
          size="small"
          //   disabled={isDisableField(stateName)}
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",
            },
          }}
          label={label}
          multiline={multiline}
          rows={5}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {

            if (stateName == "deptNo") {
              setFieldValue("deptDivNo", "");
              setFieldValue("deptName", value?.find(i => i.value == e?.target?.value)?.name)
            } else if (stateName == "WhoCanApply") {
              // setFieldValue("requirements['WhoCanApply']", e?.target?.value)

              setValues({
                ...values,
                requirements: { ...values.requirements, WhoCanApply: e?.target?.value },
              })
            } else if (stateName == "deptDivNo") {
              //    setFieldValue("deptDivName",e?.target?.name) 
              setFieldValue("deptDivName", value?.find(i => i.value == e?.target?.value)?.name)
            } else if (stateName == "announcementType" && e?.target?.value !== "DEPARTMENTAL") {
              setValues({
                ...values,
                deptName: "",
                deptDivName: "",
                deptNo: "",
                division: "",
                deptDivNo: "",
                ...(e?.target?.value !== "OPEN KPP" ? { kpp: "" } : {}),
              })
            } else if (stateName == "announcementType" && e?.target?.value == "DEPARTMENTAL") {
              setValues({
                ...values,
                kpp: ""
              })
              setFieldValue("kpp", '')
            } else if (stateName == "AppointmentTypeNOA") {
              setFieldValue("AppointmentTypeNOA", e?.target?.value)
              setFieldValue("AppointmentTypeTitle", appointmentTypeOption.find((i) => i.value == e?.target?.value).name)
            } else if (stateName == "secDeptNo") {
              setFieldValue("secDeptDivNo", "");
              setFieldValue("secDeptName", value?.find(i => i.value == e?.target?.value)?.name)
            } else if (stateName == "secDeptDivNo") {
              setFieldValue("secDeptDivName", value?.find(i => i.value == e?.target?.value)?.name)
            } else if (stateName == "secondaryAnnouncementType" && e?.target?.value !== "DEPARTMENTAL") {
              setValues({
                ...values,
                secDeptName: "",
                secDeptDivName: "",
                secDeptNo: "",
                secDivision: "",
                secDeptDivNo: "",
                ...(e?.target?.value !== "OPEN KPP" ? { secondarykpp: "" } : {}),
              })
            } else if (stateName == "secondaryAnnouncementType" && e?.target?.value == "DEPARTMENTAL") {
              setValues({
                ...values,
                secondarykpp: ""
              })
              setFieldValue("secondarykpp", '')
            } else if (stateName == "closeDuration") {
              if (e?.target?.value === "CONTINUOUS") {
                setFieldValue("status", "CONTINUOUS");
                setFieldValue("dateClosed", moment(values?.datePosted || new Date()).add(1, "year").format("MM/DD/YYYY"));
              } else {
                setFieldValue("status", "CLOSED");
              }
            }

            handleChange(e);
          }}
          error={errors[stateName] ? true : false}
          helperText={errors[stateName]}
          value={values[stateName]}
        >
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option, index) => (
              <option key={index} value={option.value}  >
                {option.displayName || option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  // const [announcementStatus, setAnnouncementStatus] = useState(""); 
  const handleStatusChange = (e) => {
    // setAnnouncementStatus(e.target.value);
    setFieldValue("AnnouncementStatus", e?.target?.value)
  }
  let AnnouncementStatuses = ["Amendment", "Cancel", "Close"]
  //   {value:"Amendment",label:"Amendment"},
  //   {value:"Cancel",label:"Cancel"},
  //   {value:"Close",label:"Close"},
  // ];

  // For getting Announcement Details
  // const [announcementRequirements, setAnnouncementRequirements] = useState({});

  function transformKeys(input, keyMap) {
    const output = {};
    for (const key in input) {
      const newKey = keyMap[key] || key; // Fallback to original key if not in keyMap
      output[newKey] = input[key];
    }
    return output;
  }
  const findOldAnnouncementData = () => {
    if (!values.positionNo) {
      ShowError("Please select position")
    }
    let additionalWhere = "";
    additionalWhere = `POSITION_NO = '${values.positionNo}'`;
    try {
      axios
        .post(
          `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=1`,
          {
            tableName: "Announcement_List",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1,
            sortData: "ANNOUNCEMENT_ID desc",
            additionalWhere: additionalWhere,
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          if (response?.data?.results?.length) {
            let localReqs = response?.data?.results[response?.data?.results?.length - 1];


            if (Object.keys(localReqs).length) {

              const keyMap = {
                ANNOUNCEMENT_ID: "announcementId",
                POSITION_NO: "positionNo",
                DATE_POSTED: "datePosted",
                DATE_CLOSED: "dateClosed",
                CLOSE_DURATION: "closeDuration",
                CloseDuration: "closeDuration",
                STATUS: "status",
                DATE_ENTERED: "dateEntered",
                PAYSCALE: "payscale",
                SALARY: "salary",
                ANNOUNCEMENT_TYPE: "announcementType",
                ANALYST_ASSIGNED: "analystAssigned",
                REQUIREMENTS: "requirements",
                CREATED_BY: "createdBy",
                EDITED_BY: "editedBy",
                Grade: "grade",
                PositionTitle: "positionTitle",
                Edited_date: "editedDate",
                Hourly_Rate: "hourlyRate",
                AnnouncementTitle: "announcementTitle",
                AmendmentText: "amendmentText",
                AnnouncementStatus: "announcementStatus",
                Pay_grade: "payGrade",
                from_Step: "fromStep",
                To_Step: "toStep",
                from_Salary: "fromSalary",
                To_Salary: "toSalary",
                Secondary_ANNOUNCEMENt_Type: "secondaryAnnouncementType",
                Secondary_Pay_grade: "secondaryPayGrade",
                Sec_KPP: "secondarykpp",
                Remarks: "remarks",
                selectivefactor: "selectivefactor",
                // Add more if needed...
              };
              localReqs = transformKeys(localReqs, keyMap);


              const {
                announcementId,
                announcementType,
                dateClosed,
                datePosted,
                closeDuration,
                positionNo,
                positionTitle,
                requirements,
                status,
                deptNo,
                deptName,
                deptDivName,
                deptDivNo,
                currentProcessStatus,
                announcementStatus,
                amendmentText,
                cancellationDate,
                amendmentDate,
                closeDate,
                cancelationRemark,
                appointmentTypeNoa,
                appointmentTypeTitle,
                hashTag,
                categorieshashTag,
                testingReq,
                grade,
                payGrade,
                step,
                fromStep,
                salary,
                fromSalary,
                secondaryAnnouncementType,
                secondaryFromStep,
                secondaryFromSalary,
                secondaryToStep,
                secondaryToSalary,
                secondaryPayGrade,
                secDeptNo,
                secDeptName,
                secDeptDivName,
                secDeptDivNo,
                selectivefactor,
                remarks,
                secondarykpp
              } = localReqs;
              setIsChecked(selectivefactor)
              setValues({
                ...localReqs,
                // announcementId:
                //   announcementId && announcementId !== null && announcementId.trim(),
                deptNo: deptNo?.trim(),
                deptName: deptName,
                deptDivName: deptDivName,
                deptDivNo: deptDivNo?.trim(),
                remarks,
                announcementType:
                  announcementType &&
                  announcementType !== null &&
                  announcementType.trim(),
                positionNo: positionNo && positionNo !== null && positionNo.trim(),
                positionTitle: positionTitle && positionTitle != null && positionTitle.trim(),
                positionObj: { value: positionNo && positionNo !== null && positionNo.trim(), label: positionTitle && positionTitle != null && positionTitle.trim() },
                requirements: requirements && requirements !== null ? isJsonString(requirements) : {},
                status: status && status !== null && status.trim() || "CONTINUOUS",
                closeDuration: normalizeCloseDuration(closeDuration, status),
                // dateClosed: dateClosed && dateClosed !== null && dateClosed,
                // datePosted: datePosted && datePosted !== null && datePosted,
                // currentProcessStatus: currentProcessStatus && currentProcessStatus !== null ? currentProcessStatus : 355,
                // AnnouncementStatus: announcementStatus && announcementStatus !== null && announcementStatus,
                // AmendmentText: amendmentText && amendmentText !== null && amendmentText,
                // AmendmentDate: amendmentDate,
                // cancelationDate: cancellationDate,
                // closeDate: closeDate,
                // AppointmentTypeNOA: appointmentTypeNoa,
                // AppointmentTypeTitle: appointmentTypeTitle,
                hashTag: hashTag || "",
                categorieshashTag: categorieshashTag || "",
                testingReq: testingReq == 'Y' ? true : false,
                // CancelationRemark: cancelationRemark && cancelationRemark !== null && cancelationRemark,
                grade: grade || payGrade || "",
                payGrade: payGrade || grade || "",
                fromStep: fromStep || step || "",
                fromSalary: fromSalary || salary || "",
                secondaryAnnouncementType: secondaryAnnouncementType || "",
                secondaryFromStep: secondaryFromStep || "",
                secondaryFromSalary: secondaryFromSalary || "",
                secondaryToStep: secondaryToStep || "",
                secondaryToSalary: secondaryToSalary || "",
                secondaryPayGrade: secondaryPayGrade || "",
                secDeptNo: secDeptNo?.trim(),
                secDeptName: secDeptName,
                secDeptDivName: secDeptDivName,
                secDeptDivNo: secDeptDivNo?.trim(),
                secondarykpp: secondarykpp?.trim(),
              });
              if (hashTag && hashTag != null) {
                setTags(hashTag.split(', ').map(item => item.trim()))
              } else {
                setTags([])
              }
              if (categorieshashTag && categorieshashTag != null) {
                setCatTags(categorieshashTag.split(', ').map(item => item.trim()))
              } else {
                setCatTags([])
              }

              //end of other fields end


            }


            // setValues({
            //   ...values,
            //   requirements: {
            //     WhoCanApply: localReqs?.WhoCanApply?.trim(),
            //     QualificationRequirement: localReqs?.QualificationRequirement?.trim(),
            //     NatureofWork: localReqs?.NatureofWork?.trim(),
            //     illustrativeExofWork: localReqs?.illustrativeExofWork?.trim(),
            //     KnowledgeAbilitiesSkills: localReqs?.KnowledgeAbilitiesSkills?.trim(),
            //     MinimumEducationReq: localReqs?.MinimumEducationReq?.trim(),
            //     DocRequirement: localReqs?.DocRequirement?.trim(),
            //     SuitabilityDeterminationForm: localReqs?.SuitabilityDeterminationForm?.trim(),
            //     ProhibitionPursuant: localReqs?.ProhibitionPursuant?.trim(),
            //     ExaminationReq: localReqs?.ExaminationReq?.trim(),
            //     InterviewProcedures: localReqs?.InterviewProcedures?.trim(),
            //     EmploymentMedicalExamination: localReqs?.EmploymentMedicalExamination?.trim(),
            //     WorkEligibility: localReqs?.WorkEligibility?.trim(),
            //     DrugScreening: localReqs?.DrugScreening?.trim(),
            //     PoliceCourtClearances: localReqs?.PoliceCourtClearances?.trim(),
            //     WhereToApply: localReqs?.WhereToApply?.trim(),
            //     ForMoreInfo: localReqs?.ForMoreInfo?.trim(),
            //     ExaminationRequirements:localReqs?.ExaminationRequirements?.trim(),
            //     NecessarySpecialQualifications:localReqs?.NecessarySpecialQualifications?.trim(),
            //     SelectiveFactor:localReqs?.SelectiveFactor?.trim()
            //   }
            // });
          } else {
            ShowError("No Announcement Data Found!")
          }
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
        });
    } catch (err) {
      setPositionTitleOptions({ data: [], isLoading: false });
    }
    // if (newValues?.positionNo) {
    //   handleCopyContent()
    // }

  }
  const generateAnnouncementData = () => {
    let additionalWhere = "";
    if (newValues?.positionNo) {
      additionalWhere = `PositionNo = '${newValues?.positionNo}'`;
    } else {
      additionalWhere = `PositionNo = '${values?.positionNo}'`;
    }

    // Har nayi call ka ek unique ID — purani call ka response aane par ignore karo
    const requestId = (generateAnnouncementRequestIdRef.current || 0) + 1;
    generateAnnouncementRequestIdRef.current = requestId;

    clearJaRegistryRequirements();
    try {
      axios
        .post(
          `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=1`,
          {
            tableName: "JA_Registry",
            searchParams: "[]",
            columns: "*",
            pageNumber: 1,
            pageSize: 1,
            sortData: "",
            additionalWhere: additionalWhere,
            qID: 0,
            location: "global",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          // Agar yeh purani call ka response hai toh ignore karo
          if (generateAnnouncementRequestIdRef.current !== requestId) return;

          if (response?.data?.results?.length) {
            let localReqs = response?.data?.results[response?.data?.results?.length - 1];
            applyJaRegistryRequirements(localReqs);
            ShowSucess(`Announcement Data content copied permanently for position ${values?.positionTitle}!`);
          } else {
            // Position ke liye JA_Registry mein koi data nahi — fields clear karo
            ShowError("No Announcement Data Found!")
            clearJaRegistryRequirements();
          }
        })
        .catch((error) => {
          if (generateAnnouncementRequestIdRef.current !== requestId) return;
          console.warn("Cannot retrieve user data", error);
          clearJaRegistryRequirements();
        });
    } catch (err) {
      setPositionTitleOptions({ data: [], isLoading: false });
    }
  }

  useEffect(() => {
    if (!ANNOUNCEMENT_ID || ANNOUNCEMENT_ID === "new") {
      return;
    }

    const currentPositionNo = String(jobAnnouncementDetails?.positionNo || values?.positionNo || "").trim();
    if (!currentPositionNo) {
      return;
    }

    // GET se aaya hua saved data — yahi primary source hai
    const savedRequirements =
      jobAnnouncementDetails?.requirements && jobAnnouncementDetails?.requirements !== null
        ? isJsonString(jobAnnouncementDetails?.requirements)
        : values?.requirements;

    let isCancelled = false;

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global?pageNumber=1&pageSize=1`,
        {
          tableName: "JA_Registry",
          searchParams: "[]",
          columns: "*",
          pageNumber: 1,
          pageSize: 1,
          sortData: "",
          additionalWhere: `PositionNo = '${currentPositionNo}'`,
          qID: 0,
          location: "global",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      )
      .then((response) => {
        if (isCancelled) return;

        if (response?.data?.results?.length) {
          const localReqs = response.data.results[response.data.results.length - 1];

          // GET ka saved data primary — JA_Registry sirf un fields ke liye jahan saved data empty ho
          const mergedReqs = buildJaRegistryRequirements(savedRequirements || {}, localReqs);

          // Sirf wahi fields disable hogi jo saved mein empty thin aur JA_Registry ne fill ki hain
          const jaSupplementedKeys = new Set(
            Object.keys(emptyAnnouncementRequirements).filter((key) => {
              const savedVal = String((savedRequirements || {})?.[key] || "").trim();
              const jaVal = String(localReqs?.[key] || "").trim();
              return !savedVal && jaVal;
            })
          );

          setJaRegistryDisabledFields(jaSupplementedKeys);
          setValues((prev) => ({
            ...prev,
            requirements: {
              ...(prev?.requirements || {}),
              ...mergedReqs,
            },
          }));
          return;
        }

        // JA_Registry mein koi data nahi — sirf saved GET data dikhao
        clearJaRegistryRequirements(savedRequirements);
      })
      .catch((registryError) => {
        if (isCancelled) return;
        console.warn("Cannot retrieve JA_Registry data", registryError);
        clearJaRegistryRequirements(savedRequirements);
      });

    return () => {
      isCancelled = true;
    };
  }, [ANNOUNCEMENT_ID, jobAnnouncementDetails]);

  const handleCopyContent = () => {
    // Show confirmation dialog
    const isConfirmed = window.confirm(
      `Are you sure you want to copy the announcement content data permanently for position ${values?.positionTitle}?`
    );

    if (!isConfirmed) {
      ShowWarning(`Announcement content data was loaded but not permanently copied for the position ${values?.positionTitle}!`);
      return;
    }

    const payload = {
      fromPositionNo: newValues?.positionNo,
      toPositionNo: values?.positionNo,
    };

    try {
      axios
        .post(
          `${process.env.REACT_APP_API_DOTNET_URL}/JARegistry/Ja_Registries`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          ShowSucess(`Announcement Data content copied permanently for position ${values?.positionTitle}!`);
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
          ShowError(getFormalApiErrorMessage(error));
        });
    } catch (err) {
      console.error("Unexpected error:", err);
      ShowError("No Announcement Data Found!");
    }
  };

  useEffect(() => {
    if (!processStatusList || processStatusList?.length == 0) {
      dispatch(getProcessesStatusList(130));
    }
  }, [dispatch, processStatusList]);

  // interest tag selection
  const [tags, setTags] = useState([]);
  const [catTags, setCatTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [editingTagIndex, setEditingTagIndex] = useState(null);
  const [jobOptionsList, setJobOptionList] = useState([]);
  const [jobOptionsCatList, setJobOptionCatList] = useState([]);
  const [jobTypeOptionsList, setJobTypeOptionsList] = useState([]);
  const [showSupplementModal, setShowSupplementModal] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState('');
  const [positionRequestRes, setPositionRequestRes] = useState([]);
  const [supplementalRequirementsData, setSupplementalRequirementsData] = useState([]);
  const reqCombinedTabsRef = useRef();

  useEffect(() => {
    if (!jobOptionsList.length) {
      return;
    }

    const matchedJob = jobOptionsList.find(
      (i) => i?.id == values?.positionNo
    );

    if (!matchedJob) {
      return;
    }

    setSelectedPostionNo((prev) => {
      const prevList = Array.isArray(prev) ? prev : [];
      if (prevList.includes(matchedJob.id)) {
        return prevList;
      }
      return [...prevList, matchedJob.id];
    });

    // Do not override user's manual role selections; prefill only when empty.
    setTags((prev) => {
      const prevList = Array.isArray(prev) ? prev : [];
      if (prevList.length > 0) {
        return prevList;
      }
      return [matchedJob.value];
    });
  }, [jobOptionsList, values?.positionNo]);

  useEffect(() => {
    if (!jobOptionsCatList.length || !values?.categorieshashTag) {
      return;
    }
    const mappedCategories = mapCategoryTagsToOptions(
      parseTagString(values?.categorieshashTag),
      jobOptionsCatList
    );
    setCatTags((prev) => {
      const prevList = Array.isArray(prev) ? prev : [];
      const isSame =
        mappedCategories.length === prevList.length &&
        mappedCategories.every((item, index) => item === prevList[index]);
      return isSame ? prevList : mappedCategories;
    });
  }, [jobOptionsCatList, values?.categorieshashTag]);

  const getOptions = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL
    const payload = {
      "tableName": "vw_job_interest",
      "SearchParams": "",
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "label",
      "sortBy": "asc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": ""
    }
    axios
      .post(`${newBaseURL}/JobApplicantAdvanceSearch/JobApplicant-global`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },

        }
      )
      .then((response) => {
        const uniquePositions = [];
        const seenPositionNos = new Set();

        response.data?.results.forEach((k) => {
          if (!seenPositionNos.has(k.NPOSITION_NO)) {
            seenPositionNos.add(k.NPOSITION_NO);
            uniquePositions.push({ label: `${k.title} (${k.NPOSITION_NO})`, value: k.NPOSITION_NO, id: k.NPOSITION_NO });
          }
        });

        setJobOptionList(uniquePositions);
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });

    const payload2 = {
      "tableName": "vw_Lk_AreaOfConsidration",
      "SearchParams": "",
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "ID",
      "sortBy": "asc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": ""
    }
    axios
      .post(`${newBaseURL}/AdvanceSearch/global`, payload2,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },

        }
      )
      .then((response) => {
        let listAll = response.data?.results;

        setJobTypeOptionsList(listAll)
        let createobject = []
        listAll.map((i) => {
          createobject.push({
            name: i.AreaOfConsidration || i.areaOfConsidration,
            value: i.AreaOfConsidration || i.areaOfConsidration,
          })
        })

        // announcementTypeOption.map(item => item.Name)
        setAnnouncementTypeOption(createobject)
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };
  const getCatOptions = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL
    const payload = {
      "tableName": "Lk_Jobcategories",
      "SearchParams": "",
      "columns": " title",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "label",
      "sortBy": "asc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": ""
    }
    axios
      .post(`${newBaseURL}/JobApplicantAdvanceSearch/JobApplicant-global`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },

        }
      )
      .then((response) => {
        setJobOptionCatList(response.data?.results.map((k) => { return { label: k.title, value: k.title } }))
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };


  useEffect(() => {
    getOptions()
    getCatOptions()
    // Use positionRequirements data if available
    if (positionRequirements.length === 0) {
      setSelectedVersion('');
    } else if (positionRequirements.length > 0) {
      if (!id || id === "new") {
        // For new announcement, use latest version from positionRequirements
        const latestPosition = positionRequirements.reduce((prev, current) =>
          (prev.requirementVersion > current.requirementVersion) ? prev : current
        );
        const requirements = latestPosition.requirements || [];
        const educationQuestions = requirements.filter(r => r.type === 'EDUCATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
        const skillQuestions = requirements.filter(r => r.type === 'SKILL').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
        const certificationQuestions = requirements.filter(r => r.type === 'CERTIFICATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
        const specializationQuestions = requirements.filter(r => r.type === 'SPECIALIZATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
        setFieldValue('educationQuestions', educationQuestions);
        setFieldValue('skillQuestions', skillQuestions);
        setFieldValue('certificationQuestions', certificationQuestions);
        setFieldValue('specializationQuestions', specializationQuestions);
        setSelectedVersion(`V${latestPosition.requirementVersion}`);
      } else {
        // For update, match positionRequestVersion with positionRequirements requirementVersion
        const positionRequestVersion = positionRequestRes[0]?.requirementVersion;
        if (positionRequestVersion) {
          const matchedPosition = positionRequirements.find(p => p.requirementVersion === positionRequestVersion);
          if (matchedPosition) {
            const requirements = matchedPosition.requirements || [];
            const educationQuestions = requirements.filter(r => r.type === 'EDUCATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
            const skillQuestions = requirements.filter(r => r.type === 'SKILL').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
            const certificationQuestions = requirements.filter(r => r.type === 'CERTIFICATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
            const specializationQuestions = requirements.filter(r => r.type === 'SPECIALIZATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
            setFieldValue('educationQuestions', educationQuestions);
            setFieldValue('skillQuestions', skillQuestions);
            setFieldValue('certificationQuestions', certificationQuestions);
            setFieldValue('specializationQuestions', specializationQuestions);
          }
          setSelectedVersion(`V${positionRequestVersion}`);
        }
      }
    }
  }, [positionRequirements, id, positionRequestRes])

  useEffect(() => {
    if (!preselectedPositionNo || (id && id !== "new")) {
      return;
    }

    if (values?.positionNo) {
      return;
    }

    const matchedPosition = findModifiedOptionByPositionNo(preselectedPositionNo);

    if (!matchedPosition) {
      return;
    }

    setValues((prev) => ({
      ...prev,
      positionNo: normalizePositionKey(matchedPosition),
      grade: (matchedPosition?.grade || "").trim(),
      positionTitle: (matchedPosition?.label || "").trim(),
      testingReq: matchedPosition?.TESTING_REQ?.trim() === "Y",
      payGrade: (matchedPosition?.grade || "").trim(),
      secondaryPayGrade: (matchedPosition?.grade || "").trim(),
    }));
    setSelectedPostion((matchedPosition?.label || "").trim());
  }, [preselectedPositionNo, id, modifiedOptions, values?.positionNo]);

  useEffect(() => {
    const currentPositionNo = String(values?.positionNo || "").trim();
    if (!currentPositionNo) {
      return;
    }

    const matchedPosition = findModifiedOptionByPositionNo(currentPositionNo);
    if (!matchedPosition) {
      return;
    }

    const matchedLabel = (matchedPosition?.label || "").trim();
    const matchedGrade = (matchedPosition?.grade || "").trim();
    const testingReqFlag = matchedPosition?.TESTING_REQ?.trim() === "Y";

    if (
      values?.positionTitle?.trim() === matchedLabel &&
      (values?.gg1ControlNumberOption === "with" || !matchedGrade || String(values?.grade || "").trim() === matchedGrade) &&
      Boolean(values?.testingReq) === testingReqFlag
    ) {
      return;
    }

    setValues((prev) => ({
      ...prev,
      positionNo: normalizePositionKey(matchedPosition),
      positionTitle: matchedLabel,
      testingReq: testingReqFlag,
      ...(prev?.gg1ControlNumberOption !== "with" && matchedGrade ? {
        grade: matchedGrade,
        payGrade: matchedGrade,
        secondaryPayGrade: matchedGrade,
      } : {}),
    }));
    setSelectedPostion(matchedLabel);
  }, [values?.positionNo, modifiedOptions]);

  useEffect(() => {
    if (!preselectedHrControl || (id && id !== "new")) {
      return;
    }

    if (values?.HrControl) {
      return;
    }

    setFieldValue("HrControl", preselectedHrControl);
  }, [preselectedHrControl, id, values?.HrControl, setFieldValue]);

  useEffect(() => {
    // Only pre-selects a value when the field is still empty (e.g. on load) -
    // never overrides a value the user has already picked or changed.
    if (!values?.HrControl || values?.announcementType) {
      return;
    }

    const { defaultValue, options } = primaryAnnouncementTypeConfig;
    const allowedValues = options.map((option) => option?.value || option?.name);

    if (defaultValue) {
      setFieldValue("announcementType", defaultValue);
      return;
    }

    if (allowedValues.length) {
      const defaultOpenValue = allowedValues.includes("OPEN") ? "OPEN" : allowedValues[0];
      setFieldValue("announcementType", defaultOpenValue);
    }
  }, [
    values?.HrControl,
    primaryAnnouncementTypeConfig,
    setFieldValue,
  ]);

  useEffect(() => {
    // Only pre-selects a value when the field is still empty (e.g. on load) -
    // never overrides a value the user has already picked or changed.
    if (!values?.HrControl || values?.secondaryAnnouncementType) {
      return;
    }

    const { defaultValue, options } = secondaryAnnouncementTypeConfig;
    const allowedValues = options.map((option) => option?.value || option?.name);

    if (defaultValue) {
      setFieldValue("secondaryAnnouncementType", defaultValue);
      return;
    }

    if (allowedValues.length) {
      const defaultOpenValue = allowedValues.includes("OPEN") ? "OPEN" : allowedValues[0];
      setFieldValue("secondaryAnnouncementType", defaultOpenValue);
    }
  }, [
    values?.HrControl,
    secondaryAnnouncementTypeConfig,
    setFieldValue,
  ]);

  useEffect(() => {
    if (!preselectedJobProfilerId || (id && id !== "new")) {
      return;
    }

    if (values?.JobProfilerId) {
      return;
    }

    setFieldValue("JobProfilerId", preselectedJobProfilerId);
  }, [
    preselectedJobProfilerId,
    id,
    values?.JobProfilerId,
    setFieldValue,
  ]);

  useEffect(() => {
    if (!preselectedJobProfilerName || (id && id !== "new")) {
      return;
    }

    if (values?.JobProfilerName) {
      return;
    }

    setFieldValue("JobProfilerName", preselectedJobProfilerName);
  }, [
    preselectedJobProfilerName,
    id,
    values?.JobProfilerName,
    setFieldValue,
  ]);

  useEffect(() => {
    setJobProfileInputValue(String(values?.JobProfilerName || "").trim());
  }, [values?.JobProfilerName]);

  useEffect(() => {
    setWithoutCaseJobProfileInputValue(
      String(selectedWithoutCaseJobProfileOption?.name || values?.JobProfilerName || "").trim()
    );
  }, [selectedWithoutCaseJobProfileOption, values?.JobProfilerName]);

  useEffect(() => {
    if (!isExactNrHrControl) return;
    if (values?.gg1ControlNumberOption !== "without") {
      setFieldValue("gg1ControlNumberOption", "without");
    }
    if (values?.HrControl && (!id || id === "new")) {
      setFieldValue("HrControl", "");
    }
  }, [
    isExactNrHrControl,
    values?.gg1ControlNumberOption,
    values?.HrControl,
    setFieldValue,
  ]);

  useEffect(() => {
    if (!values?.HrControl || !jobProfileOptions?.length) {
      setQualificationRequirementLoading(false);
      return;
    }

    const selectedOption = hrControlOptions?.data?.find(
      (option) => option?.value === values?.HrControl
    );
    if (!selectedOption) {
      setQualificationRequirementLoading(false);
      return;
    }

    const hrControlJobProfilerId = getHrControlJobProfilerId(selectedOption);
    const matchedJobProfile = getMatchedJobProfileById(hrControlJobProfilerId);

    const currentJobProfilerId = normalizeIdKey(values?.JobProfilerId);
    const matchedJobProfilerId = normalizeIdKey(matchedJobProfile?.id);
    const matchedJobProfilerName = matchedJobProfile?.name || "";

    if (
      currentJobProfilerId === matchedJobProfilerId &&
      (values?.JobProfilerName || "") === matchedJobProfilerName
    ) {
      setQualificationRequirementLoading(false);
      return;
    }

    const jpPositionNo = String(
      matchedJobProfile?.position_no || matchedJobProfile?.PositionNo || matchedJobProfile?.positionNo || ""
    ).trim();
    const matchedPosition = jpPositionNo
      ? modifiedOptions.find(
        (i) => String(i?.NPOSITION_NO || "").trim() === jpPositionNo
      )
      : null;

    setValues((prev) => ({
      ...prev,
      JobProfilerId: matchedJobProfile?.id || "",
      JobProfilerName: matchedJobProfile?.name || "",
      ...(matchedPosition && !String(prev?.positionNo || "").trim() ? {
        positionNo: String(matchedPosition.NPOSITION_NO).trim(),
        positionTitle: (matchedPosition?.label || "").trim(),
        grade: (selectedOption?.toPayGrade || matchedPosition?.grade || "").trim(),
        payGrade: (selectedOption?.toPayGrade || matchedPosition?.grade || "").trim(),
        secondaryPayGrade: (selectedOption?.toPayGrade || matchedPosition?.grade || "").trim(),
        testingReq: matchedPosition?.TESTING_REQ?.trim() === "Y",
      } : {}),
    }));
    if (matchedPosition && !String(values?.positionNo || "").trim()) {
      setSelectedPostion((matchedPosition?.label || "").trim());
    }
    setQualificationRequirementLoading(false);
  }, [
    values?.HrControl,
    values?.JobProfilerId,
    values?.JobProfilerName,
    hrControlOptions?.data,
    jobProfileOptions,
    modifiedOptions,
  ]);

  useEffect(() => {
    const matchedCopyPosition =
      copyModifiedOptions.find(
        (i) => normalizePositionKey(i) === String(values?.positionNo || "").trim()
      ) ||
      copyModifiedOptions.find(
        (i) => i?.label?.trim() === String(values?.positionTitle || "").trim()
      );

    if (!matchedCopyPosition) {
      return;
    }

    const nextPositionNo = normalizePositionKey(matchedCopyPosition);
    const nextPositionTitle = (matchedCopyPosition?.label || "").trim();

    setNewValues((prev) => {
      const prevPositionNo = String(prev?.positionNo || "").trim();
      const prevPositionTitle = String(prev?.positionTitle || "").trim();
      if (
        prevPositionNo === nextPositionNo &&
        prevPositionTitle === nextPositionTitle
      ) {
        return prev;
      }
      return {
        ...prev,
        positionNo: nextPositionNo,
        positionTitle: nextPositionTitle,
      };
    });
  }, [
    ANNOUNCEMENT_ID,
    values?.positionNo,
    values?.positionTitle,
    copyModifiedOptions,
  ]);


  const getCatMatchedOptions = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL
    const searchCondition = JSON.stringify([
      {
        columnName: "PositionNumber",
        operator: "=",
        value: `${selectedPostionNo}`,
        dataType: "VARCHAR(Max)",
        logicOperator: "AND",
      }
    ])
    const payload = {
      "tableName": "fn_GetCategoriesByPositionNumber",
      "SearchParams": searchCondition,
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "PositionNumber",
      "sortBy": "asc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": ""
    }
    axios
      .post(`${newBaseURL}/JobApplicantAdvanceSearch/JobApplicant-global`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },

        }
      )
      .then((response) => {
        const matchedData = response.data?.results || [];
        const categories = matchedData.map((x) =>
          normalizeOptionKey(x.CategoryTitle)
        );

        const matchedValues = jobOptionsCatList
          .filter((opt) => categories.includes(normalizeOptionKey(opt.label)))
          .map((opt) => opt.value);

        setCatTags(matchedValues);

      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };
  useEffect(() => {
    if (ANNOUNCEMENT_ID && ANNOUNCEMENT_ID !== "new") {
      return;
    }
    if (!selectedPostionNo || (Array.isArray(selectedPostionNo) && !selectedPostionNo.length)) {
      return;
    }
    getCatMatchedOptions()
  }, [selectedPostionNo, ANNOUNCEMENT_ID])

  const getAuditTrailData = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL
    const searchCondition = JSON.stringify([
      {
        columnName: "ANNOUNCEMENT_ID",
        operator: "=",
        value: `${values.announcementId?.trim()}`,
        dataType: "VARCHAR(Max)",
        logicOperator: "AND",
      }
    ])
    const payload = {
      "tableName": "JA_Announcement_Log",
      "SearchParams": searchCondition,
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "Grade",
      "sortBy": "desc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": ""
    }
    setAuditTrailLoading(true);
    axios
      .post(`${newBaseURL}/JobApplicantAdvanceSearch/JobApplicant-global`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },
        }
      )
      .then((response) => {
        setAuditTrailData(response.data?.results || []);
      })
      .catch((error) => {
        console.warn("Cannot retrieve audit trail data", error);
        setAuditTrailData([]);
      })
      .finally(() => {
        setAuditTrailLoading(false);
      });
  }

  useEffect(() => {
    if (!values.announcementId) {
      setAuditTrailData([]);
      return;
    }
    getAuditTrailData();
  }, [values.announcementId]);

  const getJobTransactionLogData = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    setJobTransactionLogLoading(true);
    axios
      .get(`${newBaseURL}/JobAnnouncement/JobTransactionLog/${ANNOUNCEMENT_ID}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: currentRole,
        },
      })
      .then((response) => {
        const results = Array.isArray(response.data) ? response.data : response.data?.results || [];
        setJobTransactionLogData(results);
      })
      .catch((error) => {
        console.warn("Cannot retrieve job transaction log data", error);
        setJobTransactionLogData([]);
      })
      .finally(() => {
        setJobTransactionLogLoading(false);
      });
  };

  useEffect(() => {
    if (!ANNOUNCEMENT_ID || ANNOUNCEMENT_ID === "new") {
      setJobTransactionLogData([]);
      return;
    }
    getJobTransactionLogData();
  }, [ANNOUNCEMENT_ID]);

  const documentationFieldLabels = {
    DocRequirement: "Documentation Requirements",
    SuitabilityDeterminationForm: "Suitability Determination Form",
    ProhibitionPursuant: "Prohibition Pursuant to P.L.28-98",
    InterviewProcedures: "Interviewing Procedures",
    EmploymentMedicalExamination: "Employment Medical Examination",
    WorkEligibility: "Work Eligibility",
    DrugScreening: "Drug Screening",
    PoliceCourtClearances: "Police & Court Clearances Requirements",
    ForMoreInfo: "For More Information",
  };

  const columnsHistoryRows = useMemo(() => {
    const sortedLogs = [...(auditTrailData || [])].sort(
      (a, b) => (a?.LogId || 0) - (b?.LogId || 0)
    );
    const rows = [];
    let previousRequirements = null;
    sortedLogs.forEach((log) => {
      let requirements = {};
      try {
        requirements = log?.REQUIREMENTS ? JSON.parse(log.REQUIREMENTS) : {};
      } catch (error) {
        requirements = {};
      }
      const performedBy =
        log?.Action === "INSERT"
          ? (log?.submittedname || log?.CREATED_BY || "")?.toString().trim()
          : (log?.EDITED_BY || log?.submittedname || "")?.toString().trim();
      Object.keys(documentationFieldLabels).forEach((key) => {
        const newValue = requirements?.[key] || "";
        const oldValue = previousRequirements?.[key] || "";
        if (newValue !== oldValue) {
          rows.push({
            field: documentationFieldLabels[key],
            oldValue,
            newValue,
            performedBy,
            date: log?.LogAt,
          });
        }
      });
      previousRequirements = requirements;
    });
    return rows.reverse();
  }, [auditTrailData]);

  const historyDiffData = useMemo(() => {
    const sortedLogs = [...(auditTrailData || [])].sort((a, b) => {
      const dateA = new Date(a?.LogAt || a?.DATE_STARTED || 0).getTime();
      const dateB = new Date(b?.LogAt || b?.DATE_STARTED || 0).getTime();
      return dateB - dateA;
    });
    return sortedLogs.slice(0, 2);
  }, [auditTrailData]);

  const openHistoryDiffModal = () => {
    setHistoryDiffModalOpen(true);
  };

  const getFieldHistoryData = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const searchCondition = JSON.stringify([
      {
        columnName: "ANNOUNCEMENT_ID",
        operator: "=",
        value: `${values.announcementId?.trim()}`,
        dataType: "VARCHAR(Max)",
        logicOperator: "AND",
      },
      {
        columnName: "FIELD_NAME",
        operator: "IN",
        value: Object.keys(documentationFieldLabels).join(","),
        dataType: "VARCHAR(Max)",
        logicOperator: "AND",
      },
    ]);
    const payload = {
      "tableName": "JA_Announcement_Log",
      "SearchParams": searchCondition,
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 10000000,
      "orderBy": "DATE_STARTED",
      "sortBy": "desc",
      "orderByMultiple": "",
      "limit": 10000000000,
      "sortData": "",
      "additionalWhere": "",
    };
    setFieldHistoryLoading(true);
    axios
      .post(`${newBaseURL}/JobApplicantAdvanceSearch/JobApplicant-global`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
            Role: currentRole
          },
        }
      )
      .then((response) => {
        setFieldHistoryData(response.data?.results || []);
      })
      .catch((error) => {
        console.warn("Cannot retrieve field history data", error);
        setFieldHistoryData([]);
      })
      .finally(() => {
        setFieldHistoryLoading(false);
      });
  };

  const openFieldHistoryModal = () => {
    setFieldHistoryModalOpen(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const value = event.target.value;
      if (value.trim() !== "") {
        if (editingTagIndex !== null) {
          // Update existing tag at editingTagIndex
          const updatedTags = [...tags];
          updatedTags[editingTagIndex] = value;
          setTags(updatedTags);
          setInputValue(""); // Clear the input
          setEditingTagIndex(null); // Clear editing state
        } else {
          // Add new tag if not already in tags
          if (!tags.includes(value)) {
            // setTags([...tags, value]);
            setInputValue(""); // Clear the input
          }
        }
      }
    }
  };

  const handleChangeTags = (event, newValue) => {
    if (newValue) {
      const value = newValue.title || newValue;
      if (!tags.includes(value)) {
        // setTags([...tags, value]);
        setTags(value);
        setInputValue(""); // Clear the input field
      }
    }
  };

  const handleDelete = (chipToDelete) => {
    setTags((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const handleDocumentDelete = async (doc) => {
    try {
      const deleteResponse = await axios.delete(
        `${process.env.REACT_APP_API_DOTNET_URL}/LkOjaAnnouncementDocument/DeleteLkDocument/${doc.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      setDocumentOptions((prev) => prev.filter((d) => d.id !== doc.id));
      setDocumentSelected((prev) => prev.filter((d) => d.doc !== doc.ContentType));
      ShowSucess(deleteResponse?.data?.message || "Document deleted successfully.");
    } catch (error) {
      console.warn("Document delete failed", error);
      ShowError(getFormalApiErrorMessage(error));
    }
  };

  const handleDoubleClick = (index) => {
    setEditingTagIndex(index);
    setInputValue(tags[index]);
  };


  // Function to render dynamic question lists (Certifications, Skills, Education)
  const renderDynamicQuestions = (fieldName, sectionLabel) => {
    // Ensure the value is always an array
    const questions = Array.isArray(values[fieldName]) ? values[fieldName] : [];
    const needsYears = fieldName === 'skillQuestions';

    return (
      <div className="mt-4 p-4 border rounded bg-white">
        <Typography variant="h6" className="mb-4">
          {sectionLabel}
        </Typography>

        {questions.map((item, index) => {
          const questionText = typeof item === 'object' ? item.question : item;
          const reqYears = typeof item === 'object' ? item.reqYearsMonths : '';

          return (
            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <TextField
                fullWidth
                size="small"
                label={`Question ${index + 1}`}
                placeholder="Enter question text"
                value={questionText || ''}
                onChange={(e) => {
                  const newQuestions = [...questions];
                  if (!needsYears) {
                    newQuestions[index] = e.target.value;
                  } else {
                    if (typeof newQuestions[index] !== 'object') {
                      newQuestions[index] = { question: e.target.value, reqYearsMonths: '' };
                    } else {
                      newQuestions[index].question = e.target.value;
                    }
                  }
                  setFieldValue(fieldName, newQuestions);
                }}
                InputLabelProps={{ shrink: true }}
              />

              {needsYears && (
                <TextField
                  size="small"
                  label="Required Years"
                  type="number"
                  placeholder="0"
                  value={reqYears || ''}
                  onChange={(e) => {
                    const newQuestions = [...questions];
                    if (typeof newQuestions[index] !== 'object') {
                      newQuestions[index] = { question: newQuestions[index], reqYearsMonths: e.target.value };
                    } else {
                      newQuestions[index].reqYearsMonths = e.target.value;
                    }
                    setFieldValue(fieldName, newQuestions);
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: '120px' }}
                  inputProps={{ min: '0', step: '0.5' }}
                />
              )}

              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => {
                  const newQuestions = questions.filter((_, i) => i !== index);
                  setFieldValue(fieldName, newQuestions);
                }}
                sx={{ minWidth: 'unset', p: 1 }}
              >
                <Icon name="trash" />
              </Button>
            </div>
          );
        })}

        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Icon name="plus" />}
          onClick={() => {
            setFieldValue(fieldName, [...questions, needsYears ? { question: '', reqYearsMonths: '' } : '']);
          }}
          sx={{ mt: 2 }}
        >
          Add {sectionLabel}
        </Button>
      </div>
    );
  };

  return (
    <Fragment>
      <Form>
        <Container fluid={true}>
          <Breadcrumbs
            mainTitle={
              <Typography variant="h5">
                <Icon
                  style={{ fontSize: "25px", margin: "10px" }}
                  name="list-latin-small"
                />
                Job Announcement
              </Typography>
            }
            parent={
              isAllowedURL("/jobannouncement", userData) ? (
                <Link
                  to={`${process.env.PUBLIC_URL}/jobannouncement`}
                  className="font-light"
                >
                  Job Announcement
                </Link>
              ) : undefined
            }
            title="Details"
          />
          <div>
            <Row>
              <Col>
                <Card className="p-15" elevation={2}>
                  <CardBody className={"mb-3"}>
                    {(posting || positionRequirementsLoading || qualificationRequirementLoading || isAmendmentToggling) && loadingPanel()}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <FormControl
                        component="fieldset"
                        sx={{ marginRight: "auto" }}
                      >
                        <RadioGroup
                          row
                          name="gg1ControlNumberOption"
                          value={effectiveGg1ControlNumberOption}
                          disabled={isExistingAnnouncement}
                          onChange={(e) => {
                            setFieldValue("gg1ControlNumberOption", e.target.value);
                            if (e.target.value === "without" && (!id || id === "new")) {
                              // with → without: HrControl se auto-populate hui saari fields clear karo
                              setValues((prev) => ({
                                ...prev,
                                gg1ControlNumberOption: "without",
                                HrControl: "",
                                announcementType: "",
                                JobProfilerId: "",
                                JobProfilerName: "",
                                positionNo: "",
                                positionTitle: "",
                                positionObj: { value: "", label: "" },
                                grade: "",
                                payGrade: "",
                                secondaryPayGrade: "",
                                testingReq: false,
                                toStep: "10",
                                secondaryToStep: "18",
                                payPlan: "",
                                deptNo: "",
                                deptName: "",
                                deptDivNo: "",
                                deptDivName: "",
                                secDeptNo: "",
                                secDeptName: "",
                                secDeptDivNo: "",
                                secDeptDivName: "",
                              }));
                              setSelectedPostion("");
                              resetRecruitmentControlOptions();
                            } else if (e.target.value === "with" && (!id || id === "new")) {
                              // without → with: Job Profile se auto-populate hui saari fields clear karo
                              setValues((prev) => ({
                                ...prev,
                                gg1ControlNumberOption: "with",
                                JobProfilerId: "",
                                JobProfilerName: "",
                                positionNo: "",
                                positionTitle: "",
                                positionObj: { value: "", label: "" },
                                grade: "",
                                payGrade: "",
                                secondaryPayGrade: "",
                                testingReq: false,
                              }));
                            }
                          }}
                        >
                          <FormControlLabel
                            value="with"
                            control={<Radio size="small" />}
                            label="With Recruitment Control No"
                            disabled={isExistingAnnouncement}
                          />
                          <FormControlLabel
                            value="without"
                            control={<Radio size="small" />}
                            label="Without Recruitment Control No"
                            disabled={isExistingAnnouncement}
                          />
                        </RadioGroup>
                      </FormControl>

                      {/* <Select
                        size="small"
                        placeholder="Announcement Status"
                        id="AnnouncementStatus"
                        name="AnnouncementStatus"
                        className="m-r-10"
                        style={{ width: "200px" }}
                        variant="outlined"
                        value={values?.AnnouncementStatus}
                        // value={{value:values?.AnnouncementStatus,label:values?.AnnouncementStatus}}
                        // onChange={(evt) => setSelectedRole(evt.target.value)}
                        onChange={handleStatusChange}
                      >
                        {AnnouncementStatuses.map((option) => (
                          <MenuItem className='p-2' key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>   */}
                      {id && id != "new" ? (
                        <>
                          <Btn
                            attrBtn={{
                              color: "primary",
                              onClick: () => {
                                handlePrint();
                                // handleSubmit(false)
                              },
                              style: { marginRight: "10px" },
                            }}
                          >
                            <Icon style={{ fontSize: "18px" }} name="print" />{" "}
                            &nbsp;Print
                          </Btn>
                          {currentRole == "AGENCY-DIRECTOR" &&
                            currentProcessStatusNameLower == "posted" ? (
                            <Btn
                              attrBtn={{
                                color: `${values?.AnnouncementStatus == "Amendment"
                                  ? "secondary"
                                  : "primary"
                                  }`,
                                disabled:
                                  isAmendmentToggling ||
                                  values?.AnnouncementStatus == "Cancel" ||
                                  (values?.AnnouncementStatus == "Amendment" &&
                                    !announcementStatusChanged),
                                onClick: (e) => {
                                  if (announcementStatusChanged) {
                                    // turning Amendment mode OFF
                                    const snapshot = preAmendmentValuesRef.current;
                                    const hasChanges =
                                      snapshot &&
                                      JSON.stringify(snapshot) !== JSON.stringify(values);
                                    if (hasChanges) {
                                      const isConfirmed = window.confirm(
                                        "All changes made since the amendment will be reverted. Are you sure you want to continue?"
                                      );
                                      if (!isConfirmed) return;
                                    }
                                    setIsAmendmentToggling(true);
                                    setTimeout(() => {
                                      if (snapshot) {
                                        setValues(snapshot);
                                      } else {
                                        setFieldValue("AnnouncementStatus", "");
                                        setFieldValue("AmendmentText", "");
                                      }
                                      preAmendmentValuesRef.current = null;
                                      setHighlightAmendmentText(false);
                                      setAnnouncementStatusChanged(false);
                                      setIsAmendmentToggling(false);
                                    }, 0);
                                  } else {
                                    // turning Amendment mode ON
                                    setIsAmendmentToggling(true);
                                    setTimeout(() => {
                                      preAmendmentValuesRef.current = {
                                        ...values,
                                        requirements: { ...values?.requirements },
                                      };
                                      setFieldValue("AnnouncementStatus", "Amendment");
                                      setHighlightAmendmentText(true);
                                      setAnnouncementStatusChanged(true);
                                      if (!values.AmendmentText?.trim())
                                        ShowWarning("Please Add Amendment Text!");
                                      setIsAmendmentToggling(false);
                                    }, 0);
                                  }
                                },

                                style: { marginRight: "10px" },
                              }}
                            >
                              <Icon
                                style={{ fontSize: "18px" }}
                                name="border-color"
                              />{" "}
                              &nbsp;Amendment
                            </Btn>
                          ) : null}
                          {jobAnnouncementQAClaim == "YES" ? (
                            <Btn
                              attrBtn={{
                                color: isUpdatePostedActive ? "secondary" : "primary",
                                onClick: (e) => {
                                  e.preventDefault();
                                  setIsUpdatePostedActive((prev) => !prev);
                                },
                                style: { marginRight: "10px" },
                              }}
                            >
                              <Icon
                                style={{ fontSize: "18px" }}
                                name="border-color"
                              />{" "}
                              &nbsp;Update Posted
                            </Btn>
                          ) : null}
                          <Btn
                            attrBtn={{
                              color: `${values?.AnnouncementStatus == "Cancel"
                                ? "secondary"
                                : "primary"
                                }`,
                              disabled: values?.AnnouncementStatus == "Cancel",
                              onClick: (e) => {
                                e.preventDefault();
                                setCancelRemarkInput(values?.CancelationRemark || "");
                                setCancelRemarkError(false);
                                setOpenCancelModal(true);
                              },

                              style: { marginRight: "10px" },
                            }}
                          >
                            <Icon style={{ fontSize: "18px" }} name="cancel" />{" "}
                            &nbsp;Cancel
                          </Btn>
                          {/* <Btn
                            attrBtn={{
                              color: `${values?.AnnouncementStatus == "Close" ? "secondary" : "primary"}`,
                              onClick: (e) => {
                                if (values?.AnnouncementStatus == "Close")
                                  setFieldValue("AnnouncementStatus", "");
                                else setFieldValue("AnnouncementStatus", "Close");
                                // ShowSucess("Announcement Closed Successfully!")
                                setAnnouncementStatusChanged(true);
                              },

                              style: { marginRight: "10px" },
                            }}
                          >
                            <Icon style={{ fontSize: "18px" }} name="x-outline" />{" "}
                            &nbsp;Close
                          </Btn> */}
                        </>
                      ) : null}
                      <Btn
                        attrBtn={{
                          color: "primary",
                          disabled: (isUpdatePostedQAOverride || values?.AnnouncementStatus === "Amendment")
                            ? false
                            : (!canEditByStatusAndRole && !isQAStatus),
                          onClick: (e) => {
                            e.preventDefault();
                            if (isUpdatePostedActive) {
                              setIsUpdatePostedActive(false);
                            }
                            if (!id || id == "new") {
                              setFieldValue("isSave", false);
                              handleSubmit();
                            } else if (values?.AnnouncementStatus == "Amendment") {
                              if (checkInputValidations()) {
                                const isConfirmed = window.confirm(
                                  "Are you sure you want to repost this announcement with the amended changes?"
                                );
                                if (isConfirmed) {
                                  shouldReloadAfterAmendmentSaveRef.current = true;
                                  setFieldValue("isSave", true);
                                  handleSubmit();
                                }
                              }
                            } else {
                              if (
                                values?.AnnouncementStatus != "" &&
                                (values?.AnnouncementStatus == "Cancel" ||
                                  values?.AnnouncementStatus == "Close")
                              ) {
                                // setFieldValue("isSave", false);
                                if (checkInputValidations()) {
                                  setOpenStatusModal(true);
                                }
                              } else {
                                setFieldValue("isSave", true);
                                handleSubmit();
                              }
                            }
                          },

                          style: { marginRight: "10px" },
                        }}
                      >
                        <Icon style={{ fontSize: "18px" }} name="save" />{" "}
                        &nbsp;Save
                      </Btn>
                      <Btn
                        attrBtn={{
                          color: "primary",
                          disabled: !canEditByStatusAndRole && !isQAStatus && !isAgencyDirectorStatus && !isSupervisorRoleStatus,
                          onClick: async () => {
                            const formErrors = await validateForm();
                            if (Object.keys(formErrors).length > 0) {
                              handleSubmit();
                              const errorMessages = Object.values(formErrors).flat().filter(Boolean);
                              errorMessages.forEach((msg) => ShowError(msg));
                              const firstErrorKey = Object.keys(formErrors)[0];
                              const el = document.getElementById(firstErrorKey) || document.querySelector(`[name="${firstErrorKey}"]`);
                              if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
                              return;
                            }
                            if (
                              values?.AnnouncementStatus != "" &&
                              (values?.AnnouncementStatus == "Amendment" ||
                                values?.AnnouncementStatus == "Cancel" ||
                                values?.AnnouncementStatus == "Close")
                            ) {
                              if (checkInputValidations()) {
                                setOpenStatusModal(true);
                              }
                            } else {
                              setOpenStatusModal(true);
                            }
                          },
                          style: { marginRight: "10px" },
                        }}
                      >
                        <Icon style={{ fontSize: "18px" }} name="save" />{" "}
                        &nbsp;Submit
                      </Btn>

                      {/* <Btn
                      attrBtn={{
                        color: "primary",
                        onClick: handleReset,
                        style: { margin: "0 10px" },
                      }}
                    >
                      <Icon style={{ fontSize: '18px' }} name="reset-sm" /> &nbsp;Reset{" "}
                    </Btn> */}

                      <Btn
                        attrBtn={{
                          color: "primary",
                          onClick: handleBack,
                          // style: { marginLeft: "10px" },
                          style: { marginRight: "10px" },
                        }}
                      >
                        <Icon style={{ fontSize: "18px" }} name="arrow-left" />{" "}
                        &nbsp;Back{" "}
                      </Btn>
                    </div>
                    {ANNOUNCEMENT_ID && ANNOUNCEMENT_ID !== "new" ? (
                      <AnnouncementWorkflow
                        currentValue={values?.currentProcessStatus}
                        ProcessID={130}
                      />
                    ) : null}
                    <AnnouncementStatusChangeModal
                      currentStatus={values?.currentProcessStatus || 355}
                      isOpen={openStatusModal}
                      handleClose={() => {
                        setOpenStatusModal(false);
                      }}
                      // overallRating={values?.performanceRating}
                      processStatusList={processStatusList}
                      setFieldValue={setFieldValue}
                      // isGG1Transaction={true}
                      handleSubmit={handleSubmit}
                      AnnouncementStatus={values?.AnnouncementStatus}
                      AnnouncementStatusChanged={announcementStatusChanged}
                      onNewStatusSelected={(newStatus) => { pendingStatusRef.current = newStatus; }}
                    />
                    <Dialog
                      open={openCancelModal}
                      onClose={() => setOpenCancelModal(false)}
                      fullWidth
                    >
                      <DialogTitle>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          Cancel Announcement
                          <IconButton onClick={() => setOpenCancelModal(false)}>
                            <CloseIcon />
                          </IconButton>
                        </div>
                      </DialogTitle>
                      <DialogContent>
                        <TextField
                          autoFocus
                          margin="dense"
                          variant="outlined"
                          style={{ width: "100%" }}
                          size="small"
                          label="Cancellation Remark"
                          multiline
                          rows={4}
                          required
                          InputLabelProps={{ shrink: true }}
                          value={cancelRemarkInput}
                          onChange={(e) => {
                            setCancelRemarkInput(e.target.value);
                            if (e.target.value?.trim()) setCancelRemarkError(false);
                          }}
                          error={cancelRemarkError}
                          helperText={cancelRemarkError ? "Cancellation Remark is required" : ""}
                        />
                      </DialogContent>
                      <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
                        <Btn
                          attrBtn={{
                            color: "primary",
                            onClick: () => {
                              if (!cancelRemarkInput || !cancelRemarkInput.trim()) {
                                setCancelRemarkError(true);
                                ShowError("Please Insert Cancellation Remark!");
                                return;
                              }
                              setFieldValue("AnnouncementStatus", "Cancel");
                              setFieldValue("CancelationRemark", cancelRemarkInput);
                              setAnnouncementStatusChanged(true);
                              setOpenCancelModal(false);
                              setFieldValue("isSave", false);
                              handleSubmit();
                            },
                            style: { marginRight: "10px" },
                          }}
                        >
                          Save
                        </Btn>
                        <Btn
                          attrBtn={{
                            color: "secondary",
                            onClick: () => setOpenCancelModal(false),
                          }}
                        >
                          Close
                        </Btn>
                      </DialogActions>
                    </Dialog>
                    {/* Form Start  */}
                    <fieldset
                      disabled={isFormForceDisabled}
                      style={{
                        border: 0,
                        margin: 0,
                        padding: 0,
                        minInlineSize: "auto",
                        ...(isFormForceDisabled ? { pointerEvents: "none" } : {}),
                      }}
                    >
                      {ANNOUNCEMENT_ID && ANNOUNCEMENT_ID !== "new" && !["with", "without"].includes(effectiveGg1ControlNumberOption) ? (
                        <Row>
                          <Col item xs={12} sm={6}>
                            {/* <TextField
                            name={"announcementId"}
                            label={"Announcement Id"}
                            readOnly={true}
                          /> */}
                            {renderTextInput(
                              "announcementId",
                              "Announcement Id",
                              false,
                              true
                            )}
                          </Col>
                        </Row>
                      ) : null}



                      <Row>
                        {isExistingAnnouncement && effectiveGg1ControlNumberOption === "with" && (
                          <Col md={6}>
                            {renderTextInput(
                              "announcementId",
                              "Announcement Id",
                              false,
                              true
                            )}
                          </Col>
                        )}
                        {isExistingAnnouncement && effectiveGg1ControlNumberOption === "without" && (
                          <>
                            <Col md={3}>
                              {renderTextInput(
                                "announcementId",
                                "Announcement Id",
                                false,
                                true
                              )}
                            </Col>
                            <Col md={3}>
                              {renderTextInput(
                                "positionTitle",
                                "Position Title",
                                false,
                                true
                              )}
                            </Col>
                            <Col md={3}>
                              {renderTextInput(
                                "positionNo",
                                "Position No",
                                false,
                                true
                              )}
                            </Col>
                            <Col md={3}>
                              {renderTextInput(
                                "HrControl",
                                "Recruitment Control No",
                                false,
                                true
                              )}
                            </Col>
                          </>
                        )}
                        {effectiveGg1ControlNumberOption !== "without" && (
                          <Col md={6}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              style={{ marginTop: "10px" }}
                              id="HrControl"
                              disabled={effectiveGg1ControlNumberOption === "without"}
                              options={hrControlOptions.data}
                              loading={hrControlOptions.isLoading}
                              getOptionLabel={(option) => option?.label || ""}
                              value={
                                effectiveGg1ControlNumberOption === "without"
                                  ? null
                                  : selectedHrControlOption
                              }
                              onOpen={() => {
                                if (effectiveGg1ControlNumberOption === "without") return;
                                if (!hrControlOptions.data.length) {
                                  getHrControlOptions(values?.positionNo);
                                }
                              }}
                              onChange={(e, v) => {
                                if (effectiveGg1ControlNumberOption === "without") return;
                                const selectedHrControl = v?.value || "";
                                setQualificationRequirementLoading(Boolean(selectedHrControl));
                                const selectedHrControlJobProfilerId = getHrControlJobProfilerId(v);
                                const matchedJobProfile = getMatchedJobProfileById(
                                  selectedHrControlJobProfilerId
                                );
                                const nextConfig = getAnnouncementTypeConfigByArea(v?.areaOfConsideration);
                                const nextAllowedValues = nextConfig.options.map(
                                  (option) => option?.value || option?.name
                                );
                                // A newly selected HR Control's area (Department/Govt-wide) dictates the
                                // correct type, so it takes priority over whatever was picked before -
                                // otherwise dept/division fields below (matched to the new HR Control)
                                // would end up paired with a stale, mismatched announcement type.
                                const nextAnnouncementType = nextConfig.defaultValue
                                  ? nextConfig.defaultValue
                                  : (values?.announcementType
                                    ? values?.announcementType
                                    : (nextAllowedValues.includes("OPEN") ? "OPEN" : (nextAllowedValues[0] || "")));

                                const jpPositionNo = String(
                                  matchedJobProfile?.position_no || matchedJobProfile?.PositionNo || matchedJobProfile?.positionNo || ""
                                ).trim();
                                const matchedPosition = jpPositionNo
                                  ? modifiedOptions.find(
                                    (i) => String(i?.NPOSITION_NO || "").trim() === jpPositionNo
                                  )
                                  : null;

                                const toDeptKey = String(v?.toDeptKey || "").trim();
                                const toDivisionName = String(v?.toDivisionName || "").trim().toLowerCase();
                                const matchedDivision = toDeptKey && toDivisionName
                                  ? divisionList.find((div) =>
                                    String(div.deptNo || "").trim() === toDeptKey &&
                                    (
                                      String(div.name || "").trim().toLowerCase() === toDivisionName ||
                                      String(div.displayName || "").toLowerCase().includes(toDivisionName)
                                    )
                                  )
                                  : null;

                                setValues((prev) => ({
                                  ...prev,
                                  HrControl: selectedHrControl,
                                  toStep: "10",
                                  secondaryToStep: "18",
                                  payPlan: v?.payPlan || "",
                                  deptNo: v?.toDeptKey || "",
                                  deptName: v?.toDepartment || "",
                                  deptDivNo: matchedDivision?.value || "",
                                  deptDivName: v?.toDivisionName || "",
                                  secDeptNo: v?.toDeptKey || "",
                                  secDeptName: v?.toDepartment || "",
                                  secDeptDivNo: matchedDivision?.value || "",
                                  secDeptDivName: v?.toDivisionName || "",
                                  announcementType: selectedHrControl ? nextAnnouncementType : prev?.announcementType,
                                  JobProfilerId: matchedJobProfile?.id || "",
                                  JobProfilerName: matchedJobProfile?.name || "",
                                  ...(matchedPosition ? {
                                    positionNo: String(matchedPosition.NPOSITION_NO).trim(),
                                    positionTitle: (matchedPosition?.label || "").trim(),
                                    grade: (v?.toPayGrade || matchedPosition?.grade || "").trim(),
                                    payGrade: (v?.toPayGrade || matchedPosition?.grade || "").trim(),
                                    secondaryPayGrade: (v?.toPayGrade || matchedPosition?.grade || "").trim(),
                                    testingReq: matchedPosition?.TESTING_REQ?.trim() === "Y",
                                  } : {
                                    positionNo: "",
                                    positionTitle: "",
                                    grade: (v?.toPayGrade || "").trim(),
                                    payGrade: (v?.toPayGrade || "").trim(),
                                    secondaryPayGrade: (v?.toPayGrade || "").trim(),
                                    testingReq: false,
                                  }),
                                }));
                                setSelectedPostion(matchedPosition ? (matchedPosition?.label || "").trim() : "");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Recruitment Control No"
                                  InputLabelProps={{ shrink: true }}
                                  error={(touched.HrControl || submitCount > 0) && Boolean(errors.HrControl)}
                                  helperText={(touched.HrControl || submitCount > 0) && errors.HrControl}
                                />
                              )}
                            />
                          </Col>
                        )}
                        {/* Job Profile selection hidden for the "Without Recruitment Control No" case */}
                        {!(isExistingAnnouncement && effectiveGg1ControlNumberOption === "with") &&
                          effectiveGg1ControlNumberOption !== "without" && (
                          <Col
                            md={
                              effectiveGg1ControlNumberOption === "without"
                                ? (isExistingAnnouncement ? 6 : 4)
                                : 6
                            }
                          >
                            <Autocomplete
                              size="small"
                              disablePortal
                              openOnFocus
                              style={{ marginTop: "10px" }}
                              id="JobProfilerName"
                              disabled={effectiveGg1ControlNumberOption === "with"}
                              options={withoutCaseJobProfileOptions}
                              getOptionLabel={(option) => option?.name || ""}
                              isOptionEqualToValue={(option, value) =>
                                normalizeIdKey(option?.id || option?.name) ===
                                normalizeIdKey(value?.id || value?.name)
                              }
                              filterOptions={(options) => options}
                              inputValue={withoutCaseJobProfileInputValue}
                              onInputChange={(_, newInputValue, reason) => {
                                if (reason === "reset") {
                                  setWithoutCaseJobProfileInputValue(newInputValue || String(values?.JobProfilerName || "").trim());
                                  return;
                                }
                                setWithoutCaseJobProfileInputValue(newInputValue);
                              }}
                              value={selectedWithoutCaseJobProfileOption}
                              onChange={(e, v) => {
                                setQualificationRequirementLoading(Boolean(v));
                                if (!v) {
                                  setValues((prev) => ({
                                    ...prev,
                                    JobProfilerId: "",
                                    JobProfilerName: "",
                                    positionNo: "",
                                    positionTitle: "",
                                    grade: "",
                                    payGrade: "",
                                    secondaryPayGrade: "",
                                    testingReq: false,
                                  }));
                                  setWithoutCaseJobProfileInputValue("");
                                  setSelectedPostion("");
                                  setQualificationRequirementLoading(false);
                                  return;
                                }

                                // Job Profile name drives jobProfileMatchedPositionOptions;
                                // Position Title is cleared so the user picks from those matches.
                                setValues((prev) => ({
                                  ...prev,
                                  JobProfilerId: v?.id || "",
                                  JobProfilerName: v?.name || "",
                                  positionNo: "",
                                  positionTitle: "",
                                  grade: "",
                                  payGrade: "",
                                  secondaryPayGrade: "",
                                  testingReq: false,
                                }));
                                setSelectedPostion("");
                                setWithoutCaseJobProfileInputValue(String(v?.name || "").trim());
                                setQualificationRequirementLoading(false);
                              }}
                              renderOption={(props, option, index) => {
                                const key = `job-profile-without-${option?.id || option?.position_no || option?.name || "option"}-${index}`;
                                return (
                                  <li {...props} key={key}>
                                    {option?.name || ""}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Job Profile"
                                  InputLabelProps={{ shrink: true }}
                                  error={(touched.JobProfilerId || submitCount > 0) && Boolean(errors.JobProfilerId)}
                                  helperText={(touched.JobProfilerId || submitCount > 0) && errors.JobProfilerId}
                                />
                              )}
                            />
                          </Col>
                        )}
                        {effectiveGg1ControlNumberOption === "without" && !isExistingAnnouncement && (
                          <>
                            <Col md={6}>
                              <Autocomplete
                                size="small"
                                disablePortal
                                openOnFocus
                                style={{ marginTop: "10px" }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                id="positionTitle"
                                name="positionTitle"
                                value={
                                  findModifiedOptionByPositionNo(values?.positionNo) ||
                                  (values?.positionTitle
                                    ? modifiedOptions.find(
                                      (i) =>
                                        i?.label?.trim() ===
                                        values?.positionTitle?.trim()
                                    ) || null
                                    : null)
                                }
                                hasError={errors.positionNo ? true : false}
                                options={jobProfileMatchedPositionOptions}
                                getOptionLabel={(option) =>
                                  option.label ? option.label?.toString() : ""
                                }
                                onChange={
                                  (e, v) => {
                                    const nextPositionNo = normalizePositionKey(v);
                                    const isPositionChanged =
                                      String(values?.positionNo || "").trim() !== nextPositionNo;

                                    setValues((prev) => ({
                                      ...prev,
                                      positionNo: nextPositionNo,
                                      grade: (v?.grade || "").trim(),
                                      positionTitle: (v?.label || "").trim(),
                                      testingReq: v?.TESTING_REQ?.trim() === "Y",
                                      payGrade: (v?.grade || "").trim(),
                                      secondaryPayGrade: (v?.grade || "").trim(),
                                      ...(isPositionChanged
                                        ? {
                                          HrControl: "",
                                          announcementType: "",
                                          requirements: {
                                            ...(prev?.requirements || {}),
                                            ...emptyAnnouncementRequirements,
                                          },
                                        }
                                        : {}),
                                    }));
                                    if (isPositionChanged) {
                                      resetRecruitmentControlOptions();
                                    }
                                    setSelectedPostion(v?.label?.trim() || "");
                                  }
                                }
                                renderOption={(props, option, index) => {
                                  const key = `listItem-${index?.index}-${option.id}`;
                                  return (
                                    <li {...props} key={key}>
                                      {`${option.NPOSITION_NO} - ${option.label} ${option.grade ? `(${option.grade})` : ""}`}
                                    </li>
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    name="positionTitle"
                                    helperText={errors["positionNo"]}
                                    error={errors.positionNo ? true : false}
                                    label="Position Title"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                )}
                              />
                            </Col>
                            <Col md={6}>
                              {renderTextInput(
                                "positionNo",
                                "Position No",
                                false,
                                true,
                                true
                              )}
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row>
                        {isExistingAnnouncement && effectiveGg1ControlNumberOption === "with" && (
                          <Col md={4}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              openOnFocus
                              style={{ marginTop: "10px" }}
                              id="JobProfilerName"
                              disabled={effectiveGg1ControlNumberOption === "with"}
                              options={filteredJobProfileOptions.filter((o) =>
                                values?.positionTitle
                                  ? String(o?.name || "").trim().toLowerCase().includes(values.positionTitle.trim().toLowerCase())
                                  : true
                              )}
                              getOptionLabel={(option) => option?.name || ""}
                              filterOptions={(options) => options}
                              inputValue={jobProfileInputValue}
                              onInputChange={(_, newInputValue, reason) => {
                                if (reason === "reset") {
                                  setJobProfileInputValue(String(values?.JobProfilerName || "").trim());
                                  return;
                                }
                                setJobProfileInputValue(newInputValue);
                              }}
                              value={selectedJobProfileRecord}
                              onChange={(e, v) => {
                                setQualificationRequirementLoading(Boolean(v));
                                if (!v) {
                                  setValues((prev) => ({
                                    ...prev,
                                    JobProfilerId: "",
                                    JobProfilerName: "",
                                    positionNo: "",
                                    positionTitle: "",
                                    grade: "",
                                    payGrade: "",
                                    secondaryPayGrade: "",
                                    testingReq: false,
                                  }));
                                  setJobProfileInputValue("");
                                  setQualificationRequirementLoading(false);
                                  return;
                                }


                                // Match position_no (job-profiles) against NPOSITION_NO (vw_job_interest)
                                const jpPositionNo = String(
                                  v?.position_no || v?.PositionNo || v?.positionNo || ""
                                ).trim();
                                const matchedPosition = jpPositionNo
                                  ? modifiedOptions.find(
                                    (i) => String(i?.NPOSITION_NO || "").trim() === jpPositionNo
                                  )
                                  : null;

                                setValues((prev) => ({
                                  ...prev,
                                  JobProfilerId: v?.id || "",
                                  JobProfilerName: v?.name || "",
                                  ...(matchedPosition ? {
                                    positionNo: String(matchedPosition.NPOSITION_NO).trim(),
                                    positionTitle: (matchedPosition?.label || "").trim(),
                                    grade: (matchedPosition?.grade || "").trim(),
                                    payGrade: (matchedPosition?.grade || "").trim(),
                                    secondaryPayGrade: (matchedPosition?.grade || "").trim(),
                                    testingReq: matchedPosition?.TESTING_REQ?.trim() === "Y",
                                  } : {}),
                                }));
                                if (matchedPosition) {
                                  setSelectedPostion((matchedPosition?.label || "").trim());
                                }
                                setJobProfileInputValue(String(v?.name || "").trim());
                                setQualificationRequirementLoading(false);
                              }}
                              renderOption={(props, option, index) => {
                                const key = `job-profile-with-${option?.id || option?.position_no || option?.name || "option"}-${index}`;
                                return (
                                  <li {...props} key={key}>
                                    {option?.name || ""}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Job Profile"
                                  InputLabelProps={{ shrink: true }}
                                  error={(touched.JobProfilerId || submitCount > 0) && Boolean(errors.JobProfilerId)}
                                  helperText={(touched.JobProfilerId || submitCount > 0) && errors.JobProfilerId}
                                />
                              )}
                            />
                          </Col>
                        )}
                        {!(effectiveGg1ControlNumberOption === "without" && !isExistingAnnouncement) && (
                          <Col
                            md={
                              (
                                isExistingAnnouncement &&
                                ["with", "without"].includes(effectiveGg1ControlNumberOption)
                              ) ? 4 : 6
                            }
                          >
                            {/* {renderDropDown(
                          "positionTitle",
                          "Position Title",
                          positionTitleOptions
                        )} */}
                            <Autocomplete
                              size="small"
                              disablePortal
                              disableClearable
                              readOnly
                              style={{ marginTop: "10px" }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              id="positionTitle"
                              name="positionTitle"
                              value={
                                findModifiedOptionByPositionNo(values?.positionNo) ||
                                (values?.positionTitle
                                  ? modifiedOptions.find(
                                    (i) =>
                                      i?.label?.trim() ===
                                      values?.positionTitle?.trim()
                                  ) || null
                                  : null)
                              }
                              hasError={errors.positionNo ? true : false}
                              options={filteredModifiedOptions}
                              getOptionLabel={(option) =>
                                option.label ? option.label?.toString() : ""
                              }
                              onChange={
                                (e, v) => {
                                  const nextPositionNo = normalizePositionKey(v);
                                  const isPositionChanged =
                                    String(values?.positionNo || "").trim() !== nextPositionNo;

                                  setValues((prev) => ({
                                    ...prev,
                                    positionNo: nextPositionNo,
                                    grade: (v?.grade || "").trim(),
                                    positionTitle: (v?.label || "").trim(),
                                    testingReq: v?.TESTING_REQ?.trim() === "Y",
                                    payGrade: (v?.grade || "").trim(),
                                    secondaryPayGrade: (v?.grade || "").trim(),
                                    ...(isPositionChanged
                                      ? {
                                        HrControl: "",
                                        announcementType: "",
                                        JobProfilerId: "",
                                        JobProfilerName: "",
                                        requirements: {
                                          ...(prev?.requirements || {}),
                                          ...emptyAnnouncementRequirements,
                                        },
                                      }
                                      : {}),
                                  }));
                                  if (isPositionChanged) {
                                    resetRecruitmentControlOptions();
                                  }
                                  setSelectedPostion(v?.label?.trim() || "");
                                }
                              }
                              renderOption={(props, option, index) => {
                                const key = `listItem-${index?.index}-${option.id}`;
                                return (
                                  <li {...props} key={key}>
                                    {`${option.NPOSITION_NO} - ${option.label} ${option.grade ? `(${option.grade})` : ""}`}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="positionTitle"
                                  helperText={errors["positionNo"]}
                                  error={errors.positionNo ? true : false}
                                  label="Position Title"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    readOnly: true,
                                    style: { ...params.inputProps?.style, cursor: "default" },
                                  }}
                                />
                              )}
                            />
                          </Col>
                        )}
                        {!(effectiveGg1ControlNumberOption === "without" && !isExistingAnnouncement) && (
                          <Col
                            md={
                              (
                                isExistingAnnouncement &&
                                ["with", "without"].includes(effectiveGg1ControlNumberOption)
                              ) ? 4 : 6
                            }
                          >
                            {renderTextInput(
                              "positionNo",
                              "Position No",
                              false,
                              true,
                              true
                            )}
                          </Col>
                        )}
                        {isExistingAnnouncement && effectiveGg1ControlNumberOption === "without" && (
                          <Col md={4}>
                            <TextField
                              fullWidth
                              size="small"
                              style={{ marginTop: "10px" }}
                              label="HR Control"
                              value={hrControlDisplayValue}
                              inputProps={{ style: { textTransform: "none" } }}
                              InputProps={{ readOnly: true }}
                              InputLabelProps={{ shrink: true }}
                            />
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col md={6}>
                          {renderTextInput(
                            "remarks",
                            "Remarks",
                            // true,
                            // true
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderDateInput("datePosted", "Date Posted", true, (!id || id === "new") ? dayjs() : null)}
                        </Col>
                        <Col md={4}>
                          {renderDropDown(
                            "closeDuration",
                            "Date Closed Type",
                            closeDurationOptions
                          )}
                          {!values?.closeDuration && (
                            <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                              Please select Date Closed Type.
                            </Typography>
                          )}
                          {touched?.dateClosed && !!errors?.dateClosed && (
                            <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
                              {errors.dateClosed}
                            </Typography>
                          )}
                        </Col>
                        <Col md={4}>
                          {(isUpdatePostedQAOverride || isAmendmentModeActive || !isExistingAnnouncement) ? (
                            renderDateInput("dateClosed", "Date Closed", true, null, null, !values?.closeDuration, true)
                          ) : (
                            <TextField
                              fullWidth
                              size="small"
                              margin="dense"
                              variant="outlined"
                              label="Date Closed"
                              id="dateClosed"
                              value={values?.dateClosed ? moment(values.dateClosed).format("MM/DD/YYYY") : ""}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ readOnly: true, style: { fontSize: "14px", paddingTop: "12px", cursor: "not-allowed" } }}
                              sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#f2f2f2" } }}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderTextInput(
                            "payGrade",
                            "Pay Grade",
                            false,
                            false,
                            true
                          )}
                        </Col>
                        <Col md={4}>
                          {renderTextInput(
                            "fromStep",
                            "From Pay Step",
                            false,
                            true,
                            true
                          )}
                        </Col>
                        {/* <Col md={3}>{renderTextInput("hourlyRate", "Hourly Rate", false, true, true)}</Col> */}
                        <Col md={4}>
                          {renderTextInput(
                            "toStep",
                            "To Pay Step",
                            false,
                            false,
                            true
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderTextInput(
                            "fromSalary",
                            "From Salary",
                            false,
                            true,
                            true
                          )}
                        </Col>
                        <Col md={4}>
                          {renderTextInput(
                            "toSalary",
                            "To Salary",
                            false,
                            true,
                            true
                          )}
                        </Col>
                        <Col md={4}>
                          <Autocomplete
                            options={payPlansOptions?.map((name) => name?.trim())}
                            value={values?.payPlan}
                            onChange={(event, newValue) =>
                              setValues({
                                ...values,
                                payPlan: newValue,
                              })
                            }
                            size="small"
                            style={{ marginTop: "10px" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                id="payPlan"
                                label="Pay Plan"
                                variant="outlined"
                                size="small"
                                error={touched?.payPlan && !!errors?.payPlan}
                                helperText={touched?.payPlan && errors?.payPlan}
                              />
                            )}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderDropDown(
                            "announcementType",
                            "Announcement Type",
                            primaryAnnouncementTypeConfig?.options || announcementTypeOption,
                            false,
                            primaryAnnouncementTypeConfig?.isReadOnly
                          )}
                        </Col>
                        {values?.announcementType == "DEPARTMENTAL" ? (
                          <>
                            <Col md={4}>
                              {renderDropDown(
                                "deptNo",
                                "Department",
                                departmentList
                              )}
                            </Col>
                            <Col md={4}>
                              {renderDropDown(
                                "deptDivNo",
                                "Divisions",
                                filteredDivisions
                              )}
                            </Col>{" "}
                          </>
                        ) : null}

                        {values?.announcementType == 'OPEN KPP4' ?
                          <Col md={4}>
                            <FormGroup row>
                              {['KPP I', 'KPP II', 'KPP III'].map((label, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      value={label}
                                      checked={values.kpp === label ? true : false}
                                      onChange={(e) => { setFieldValue("kpp", e.target.value) }}
                                    />
                                  }
                                  label={label}
                                />
                              ))}
                            </FormGroup>
                          </Col>
                          : null}
                      </Row>

                      {/*  */}
                      <Row className="mt-1">
                        <h6>Secondary</h6>
                      </Row>
                      <Row>
                        <Col md={4}>
                          {renderTextInput(
                            "secondaryPayGrade",
                            "Pay Grade",
                            false,
                            false,
                            true
                          )}
                        </Col>
                        <Col md={4}>
                          {renderTextInput(
                            "secondaryFromStep",
                            "From Pay Step",
                            false,
                            false,
                            true
                          )}
                        </Col>
                        {/* <Col md={3}>{renderTextInput("hourlyRate", "Hourly Rate", false, true, true)}</Col> */}
                        <Col md={4}>
                          {renderTextInput(
                            "secondaryToStep",
                            "To Pay Step",
                            false,
                            false,
                            true
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderTextInput(
                            "secondaryFromSalary",
                            "From Salary",
                            false,
                            true,
                            true
                          )}
                        </Col>
                        <Col md={4}>
                          {renderTextInput(
                            "secondaryToSalary",
                            "To Salary",
                            false,
                            true,
                            true
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col md={4}>
                          {renderDropDown(
                            "secondaryAnnouncementType",
                            "Announcement Type",
                            secondaryAnnouncementTypeConfig?.options || announcementTypeOption,
                            false,
                            secondaryAnnouncementTypeConfig?.isReadOnly
                          )}
                        </Col>
                        {values?.secondaryAnnouncementType == "DEPARTMENTAL" ? (
                          <>
                            <Col md={4}>
                              {renderDropDown(
                                "secDeptNo",
                                "Department",
                                departmentList
                              )}
                            </Col>
                            <Col md={4}>
                              {renderDropDown(
                                "secDeptDivNo",
                                "Divisions",
                                secondaryFilteredDivisions
                              )}
                            </Col>{" "}
                          </>
                        ) : null}

                        {values?.secondaryAnnouncementType == 'OPEN KPP' ?
                          <Col md={4}>
                            <FormGroup row>
                              {['KPP I', 'KPP II', 'KPP III'].map((label, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      value={label}
                                      checked={values?.secondarykpp === label}
                                      onChange={(e) => { setFieldValue("secondarykpp", e.target.value) }}
                                    />
                                  }
                                  label={label}
                                />
                              ))}
                            </FormGroup>
                          </Col>
                          : null}
                      </Row>
                      {/*  */}

                      <Row>
                        <Col md={2}>
                          {renderDropDown(
                            "status",
                            "Status",
                            statusOption,
                            false,
                            false
                          )}
                        </Col>
                        <Col md={2}>
                          {renderDropDown(
                            "AppointmentTypeNOA",
                            "Appointment Type",
                            appointmentTypeOption
                          )}
                        </Col>
                        <Col md={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                              />
                            }
                            label="Selective Factor"
                          />
                        </Col>
                        {isChecked ?
                          <Col md={12}>
                            {renderTextArea(
                              "SelectiveFactor",
                              "Selective Factor",
                              true,
                              true
                            )}
                          </Col>
                          : null}
                        {ANNOUNCEMENT_ID == "new" || currentProcessStatusNameLower === "draft" ? (
                          <Col md={12}>
                            <Typography variant="h6" gutterBottom>
                              Position Requirements
                            </Typography>
                          </Col>
                        ) : null}
                        {/* <Col md={2}>
                        <FormControl sx={{ my: 1, width: '100%' }}>
                          <InputLabel id="select-version">Select Version</InputLabel>
                          <Select
                            labelId="select-version"
                            id="demo-simple-select-helper"
                            label="Select version"
                            value={selectedVersion}
                            sx={{
                              '& .MuiSelect-select': {
                                padding: '8.5px 14px'
                              }
                            }}
                            onChange={(e) => {
                              const version = e.target.value;
                              setSelectedVersion(version);

                              if (!version || !positionRequirements.length) return;

                              const selectedPosition = positionRequirements.find(p => p.requirementVersion.toString() === version.replace('V', ''));
                              if (!selectedPosition) return;

                              const requirements = selectedPosition.requirements || [];
                              const educationQuestions = requirements.filter(r => r.type === 'EDUCATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
                              const skillQuestions = requirements.filter(r => r.type === 'SKILL').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
                              const certificationQuestions = requirements.filter(r => r.type === 'CERTIFICATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));
                              const specializationQuestions = requirements.filter(r => r.type === 'SPECIALIZATION').map(r => ({ question: r.description, answerType: r.answerType, weight: r.defaultWeight, isMockData: true }));

                              setFieldValue('educationQuestions', educationQuestions);
                              setFieldValue('skillQuestions', skillQuestions);
                              setFieldValue('certificationQuestions', certificationQuestions);
                              setFieldValue('specializationQuestions', specializationQuestions);
                            }}
                          >
                            {positionRequirements.map((position, index) => (
                              <MenuItem key={position.positionId} value={`V${position.requirementVersion}`}>
                                V{position.requirementVersion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Col> */}
                        {/* Education Section */}
                        {(values?.educationQuestions || []).filter(item => item.isMockData).length > 0 && (
                          <Col md={12}>
                            <div style={{ border: '1px solid #ddd', padding: '15px', marginBottom: '15px', borderRadius: '5px' }}>
                              <h6>Education Questions</h6>

                              {/* Mock Data Questions (Read-only) */}
                              {(values?.educationQuestions || []).filter(item => item.isMockData).map((item, index) => (
                                <div key={`mock-${index}`} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
                                  <TextField
                                    size="small"
                                    label="Question"
                                    value={item.question || ''}
                                    disabled
                                    style={{ flex: 1 }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Answer Type"
                                    value={item.answerType || 'yes-no'}
                                    disabled
                                    style={{ width: '120px' }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Weight"
                                    value={item.weight || ''}
                                    disabled
                                    style={{ width: '100px' }}
                                  />
                                </div>
                              ))}
                            </div>
                          </Col>
                        )}

                        {/* Skill Section */}
                        {(values?.skillQuestions || []).filter(item => item.isMockData).length > 0 && (
                          <Col md={12}>
                            <div style={{ border: '1px solid #ddd', padding: '15px', marginBottom: '15px', borderRadius: '5px' }}>
                              <h6>Skill Questions</h6>

                              {/* Mock Data Questions (Read-only) */}
                              {(values?.skillQuestions || []).filter(item => item.isMockData).map((item, index) => (
                                <div key={`mock-${index}`} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
                                  <TextField
                                    size="small"
                                    label="Question"
                                    value={item.question || ''}
                                    disabled
                                    style={{ flex: 1 }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Answer Type"
                                    value={item.answerType || 'yes-no'}
                                    disabled
                                    style={{ width: '120px' }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Weight"
                                    value={item.weight || ''}
                                    disabled
                                    style={{ width: '100px' }}
                                  />
                                </div>
                              ))}
                            </div>
                          </Col>
                        )}

                        {/* Certification Section */}
                        {(values.certificationQuestions || []).filter(item => item.isMockData).length > 0 && (
                          <Col md={12}>
                            <div style={{ border: '1px solid #ddd', padding: '15px', marginBottom: '15px', borderRadius: '5px' }}>
                              <h6>Certification Questions</h6>

                              {/* Mock Data Questions (Read-only) */}
                              {(values.certificationQuestions || []).filter(item => item.isMockData).map((item, index) => (
                                <div key={`mock-${index}`} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
                                  <TextField
                                    size="small"
                                    label="Question"
                                    value={item.question || ''}
                                    disabled
                                    style={{ flex: 1 }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Answer Type"
                                    value={item.answerType || 'yes-no'}
                                    disabled
                                    style={{ width: '120px' }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Weight"
                                    value={item.weight || ''}
                                    disabled
                                    style={{ width: '100px' }}
                                  />
                                </div>
                              ))}
                            </div>
                          </Col>
                        )}

                        {/* Specialization Section */}
                        {(values?.specializationQuestions || []).filter(item => item.isMockData).length > 0 && (
                          <Col md={12}>
                            <div style={{ border: '1px solid #ddd', padding: '15px', marginBottom: '15px', borderRadius: '5px' }}>
                              <h6>Specialization Questions</h6>

                              {/* Mock Data Questions (Read-only) */}
                              {(values?.specializationQuestions || []).filter(item => item.isMockData).map((item, index) => (
                                <div key={`mock-${index}`} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
                                  <TextField
                                    size="small"
                                    label="Question"
                                    value={item.question || ''}
                                    disabled
                                    style={{ flex: 1 }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Answer Type"
                                    value={item.answerType || 'yes-no'}
                                    disabled
                                    style={{ width: '120px' }}
                                  />
                                  <TextField
                                    size="small"
                                    label="Weight"
                                    value={item.weight || ''}
                                    disabled
                                    style={{ width: '100px' }}
                                  />
                                </div>
                              ))}
                            </div>
                          </Col>
                        )}
                        {/* {!showSupplementModal ? <Col md={12}  >
                        <Box style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <Typography variant="h6" gutterBottom>
                            {showSupplementModal
                              ? "Supplemental information for this job announcement."
                              : "If you want to add a supplement to this job announcement."}
                          </Typography>
                          <Btn
                            attrBtn={{
                              color: "primary",
                              onClick: () => setShowSupplementModal(!showSupplementModal),
                              style: { marginRight: "10px", marginBottom: '10px' },
                            }}
                          >
                            {showSupplementModal ? (
                              "Hide Supplement"
                            ) : (
                              (supplementalRequirementsData.length > 0 ||
                                (reqCombinedTabsRef.current?.getTabQuestions() &&
                                  Object.keys(reqCombinedTabsRef.current.getTabQuestions()).length > 0))
                                ? <><Icon style={{ fontSize: "18px" }} name="eye" />&nbsp;Show Supplement</>
                                : <><Icon style={{ fontSize: "18px" }} name="plus" />&nbsp;Add Supplement</>
                            )}
                          </Btn>
                        </Box>
                      </Col>
                        :
                        <Col md={12}  >
                          <Btn
                            attrBtn={{
                              color: "primary",
                              onClick: () => setShowSupplementModal(!showSupplementModal),
                              style: { marginRight: "10px", marginBottom: '10px' },
                            }}
                          >
                            Hide Add Supplement
                          </Btn>
                        </Col>} */}

                        {/* {showSupplementModal && (
                        <Col md={12}>
                          <ReqCombinedTabsSimplified ref={reqCombinedTabsRef} supplementalData={supplementalRequirementsData} />
                        </Col>
                      )} */}
                      </Row>

                      <Row>
                        {ANNOUNCEMENT_ID == "new" || currentProcessStatusNameLower === "draft" ? (
                          <Col
                            md={4}
                            sm={4}
                            className=""
                          // style={{ backgroundColor: "#edf2fa" }}
                          >

                            <Autocomplete
                              size="small"
                              disablePortal
                              style={{ marginTop: "10px" }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              id="positionTitle"
                              name="positionTitle"
                              value={
                                copyModifiedOptions.find(
                                  (i) =>
                                    normalizePositionKey(i) ===
                                    String(newValues?.positionNo || "").trim()
                                ) ||
                                (newValues?.positionTitle
                                  ? copyModifiedOptions.find(
                                    (i) =>
                                      i?.label?.trim() ===
                                      newValues?.positionTitle?.trim()
                                  ) || null
                                  : null)
                              }
                              // hasError={errors.positionNo ? true : false}
                              options={copyModifiedOptions}
                              getOptionLabel={(option) =>
                                option.label ? option.label?.toString() : ""
                              }
                              onChange={
                                // handleChange
                                (e, v) => {
                                  // setNOA({ value: v?.value, label: v?.label } || {});
                                  setNewValues({
                                    positionNo: normalizePositionKey(v),
                                    positionTitle: v?.label?.trim(),
                                  });
                                  // setFieldValue("NOA", v);
                                }
                              }
                              // hasError={errors.NatureOf ? true : false}
                              renderOption={(props, option, index) => {
                                const key = `listItem-${index?.index}-${option.id}`;
                                return (
                                  <li {...props} key={key}>
                                    {`${option["NPOSITION_NO"]} - ${option["titleWithGrade"]}`}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="positionTitle"
                                  helperText={
                                    "Select Position Title where you want to copy the content"
                                  }
                                  // error={errors.positionNo ? true : false}
                                  label="Select Target Position Title"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              )}
                            />
                          </Col>
                        ) : null}

                        {ANNOUNCEMENT_ID == "new" || currentProcessStatusNameLower === "draft" ? (
                          <Col
                            md={4}
                            sm={4}
                            className=""
                          // style={{ backgroundColor: "#edf2fa" }}
                          >
                            <Btn
                              attrBtn={{
                                color: "primary",
                                onClick: () => {
                                  //findOldAnnouncementData();
                                  generateAnnouncementData();
                                },
                                style: {
                                  marginRight: "10px",
                                  width: "100%",
                                  marginTop: "10px",
                                },
                              }}
                            >
                              &nbsp;Generate & Load Default Announcement Content
                            </Btn>
                          </Col>
                        ) : null}

                        {/* {copyButtonShow && (
                        ANNOUNCEMENT_ID && ANNOUNCEMENT_ID !== "new" ? null : (
                          <Col md={1} sm={1} style={{ backgroundColor: "#edf2fa" }}>
                            <Btn
                              attrBtn={{
                                color: "primary",
                                onClick: handleCopyContent,
                                style: { marginRight: "10px", width: "100%", marginTop: "10px" },
                              }}
                            >
                              Copy
                            </Btn>
                          </Col>
                        )
                      )} */}
                      </Row>
                      {values?.AnnouncementStatus ? (
                        <Row>
                          <Col md={4}>
                            {renderTextInput(
                              "AnnouncementStatus",
                              "Announcement Status",
                              false,
                              true
                            )}
                          </Col>
                        </Row>
                      ) : null}

                      {values?.testingReq &&
                        (values?.testingReq == true ||
                          values?.testingReq == "Y") ? (
                        <Row>
                          <Col md={2}>
                            <FormControlLabel
                              label="Testing Required"
                              control={
                                <Checkbox checked={values?.testingReq} readOnly />
                              }
                              labelPlacement="end"
                            />
                          </Col>
                        </Row>
                      ) : null}



                    </fieldset>
                    {values?.AnnouncementStatus == "Amendment" && (
                      <Row>
                        <Col md={12}>
                          {renderTextArea(
                            "AmendmentText",
                            "Amendment",
                            true,
                            true,
                            !isAmendmentModeActive
                          )}
                        </Col>
                      </Row>
                    )}
                    {values?.AnnouncementStatus == "Cancel" && (
                      <Row>
                        <Col md={12}>
                          {renderTextInput(
                            "CancelationRemark",
                            "Cancellation Remark",
                            false,
                            !isQAStatus,
                            true,
                            true,
                            true
                          )}
                        </Col>
                      </Row>
                    )}
                    <fieldset
                      disabled={isFormForceDisabled}
                      style={{
                        border: 0,
                        margin: 0,
                        padding: 0,
                        minInlineSize: "auto",
                        ...(isFormForceDisabled ? { pointerEvents: "none" } : {}),
                      }}
                    >
                      <Row>
                        {/* document selection */}
                        <Row>
                          <Typography className="flex w-full justify-center py-8 bg-gray-200 text-gray-600  ">
                            Document For Submission
                          </Typography>
                          <Col lg={5}>
                            <TextField
                              margin="dense"
                              autoComplete="false"
                              className="flex w-full "
                              style={{ width: "100%" }}
                              variant="outlined"
                              size="small"
                              inputProps={{
                                style: {
                                  fontSize: "14px",
                                  color: "black",
                                  paddingTop: "12px",
                                },
                              }}
                              label={`Search Docs `}
                              onChange={(e) => {
                                setFilterText(e.target.value);
                              }}
                            />
                          </Col>
                          <Col lg={3}>
                            {addRecordModel ?
                              <DocTypeModel
                                isOpen={true}
                                handleClose={() => setAddRecordModel(false)}
                                updateCurrentRecordinBulk={(a, ac) => { }}
                                data={[{ FirstName: 'aaa', Id: '' }]}
                                documentOptions={documentOptions}
                                setDocumentOptions={setDocumentOptions}
                                getDocumentList={getDocumentList}
                                isUpdate={false}

                              />
                              : null}
                            {editRecordModel && editingDocument ?
                              <DocTypeModel
                                isOpen={true}
                                handleClose={() => { setEditRecordModel(false); setEditingDocument(null); }}
                                updateCurrentRecordinBulk={(a, ac) => { }}
                                data={editingDocument}
                                documentOptions={documentOptions}
                                setDocumentOptions={setDocumentOptions}
                                isUpdate={true}
                              />
                              : null}
                            <Btn
                              attrBtn={{
                                color: "primary",
                                onClick: () => {
                                  setAddRecordModel(true);
                                },
                                style: { marginRight: "10px", marginTop: '10px' },
                              }}
                            >
                              <Icon style={{ fontSize: "18px" }} name="plus" />{" "}
                              &nbsp;Add Document
                            </Btn>

                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div class="position-relative pt-2" >


                              <div style={{ height: '250px', width: '100%', overflowX: 'hidden', border: '1px solid #d2d2d2', borderRadius: '5px', padding: '5px 5px' }}>

                                <div className="docTable-table-container">
                                  <table className="table table-bordered table-hover docTable">

                                    <thead>

                                      <tr>
                                        <th className="text-center"></th>
                                        <th>Type</th>
                                        <th>Category</th>
                                        <th>Description</th>
                                        <th>Created Date</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {/* {filter((item) => {
                                      return (
                                        // documentSelected.find((d) => d.doc === item.DocType) == null &&
                                        item.DocType.toLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1
                                      );
                                    }).} */}
                                      {documentOptions.filter((item) => {
                                        return (
                                          // documentSelected.find((d) => d.doc === item.ContentType) == null &&
                                          item.ContentType.toLowerCase().indexOf(filterText?.toLocaleLowerCase()) > -1 ||
                                          item.Category.toLowerCase().indexOf(filterText?.toLocaleLowerCase()) > -1

                                        );
                                      })
                                        .sort((a, b) => {
                                          const shouldPrioritizeSelected =
                                            String(values?.currentProcessStatus || "") !== "355" &&
                                            String(values?.currentProcessStatus || "") !== "387";
                                          if (!shouldPrioritizeSelected) return 0;

                                          const isASelected = documentSelected.some((item) => item?.doc === a?.ContentType);
                                          const isBSelected = documentSelected.some((item) => item?.doc === b?.ContentType);

                                          if (isASelected === isBSelected) return 0;
                                          return isASelected ? -1 : 1;
                                        })
                                        .map((label, index) => (
                                          <tr>
                                            <td className="text-center">
                                              {/* {JSON.stringify(documentSelected)} */}
                                              <Checkbox key={`${index}x`} name={`${index}x`} style={{ margin: '0px', padding: '0px' }}
                                                value={label.ContentType}
                                                checked={documentSelected.map(item => item.doc).includes(label.ContentType)}
                                                onChange={(e) => {
                                                  let newdata = [...documentSelected];
                                                  if (e.target.checked) {
                                                    newdata.push({ ...label, doc: e.target.value, rq: false });
                                                  } else {
                                                    newdata = newdata.filter(l => l.doc != e.target.value)
                                                  }



                                                  setDocumentSelected(newdata)
                                                }}
                                              />
                                              {/* <FormControlLabel
                  key={index}
                  control={
          <Checkbox style={{margin:'0px',padding:'0px' }}
                                      value={label.ContentType}
                                      checked={documentSelected.find(k=>k.doc==label.ContentType)}
                                      onChange={(e) => {
                                        
                                      let newdata = [ ...documentSelected ];
                                      if(e.target.checked){
                                        newdata.push({...label , doc: e.target.value,rq:false });
                                      }else{
                                        newdata = newdata.filter(l=>l.doc!=e.target.value)
                                      }

                                      setDocumentSelected(newdata)
                                      }}
                                    />
                                  }
                  
                />       */}

                                            </td>
                                            <td>{label.ContentType}</td>
                                            <td>{label.Category}</td>
                                            <td>{label.Description}</td>
                                            <td>{label.CreatedDate ? moment(label.CreatedDate).format("MM/DD/YYYY") : '-'}</td>
                                            <td className="text-center">
                                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                <FormControlLabel
                                                  key={`index$${index}`}
                                                  name={`index$${index}`}
                                                  control={
                                                    <Checkbox
                                                      value={label.ContentType}
                                                      style={{ margin: '0px', padding: '0px', fontWeight: 'normal' }}
                                                      disabled={!documentSelected.find(l => l.doc == label.ContentType)}
                                                      // checked={documentSelected.find(k=>k.doc==label.ContentType && k.rq==true)}
                                                      checked={documentSelected.filter(k => k.rq).map(item => item.doc).includes(label.ContentType)}
                                                      onChange={(e) => {
                                                        let newdata = [...documentSelected];
                                                        let findx = newdata.findIndex((l) => l.doc == e.target.value)
                                                        if (e.target.checked) {
                                                          newdata[findx]['rq'] = true;
                                                        } else {
                                                          newdata[findx]['rq'] = false;
                                                        }
                                                        setDocumentSelected(newdata)
                                                      }}
                                                    />
                                                  }
                                                  label={<span style={{ fontSize: '14px', fontWeight: '300', color: '#242934' }}>Mandatory</span>}
                                                />
                                                <IconButton
                                                  size="small"
                                                  title="Edit"
                                                  onClick={() => {
                                                    setEditingDocument({ ID: label.id, DocType: label.ContentType, Category: label.Category, Descr: label.Description, Usage_Status: 'Active' });
                                                    setEditRecordModel(true);
                                                  }}
                                                  style={{ color: '#1976d2', padding: '2px' }}
                                                >
                                                  <Icon name="edit" style={{ fontSize: '16px' }} />
                                                </IconButton>
                                                <IconButton
                                                  size="small"
                                                  title="Delete"
                                                  onClick={() => handleDocumentDelete(label)}
                                                  style={{ color: '#d32f2f', padding: '2px' }}
                                                >
                                                  <Icon name="delete" style={{ fontSize: '16px' }} />
                                                </IconButton>
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              {/* <div class="border p-1">
                              <FormGroup row>
                              { 
                                documentOptions.map((label, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      value={label.ContentType}
                                      checked={documentSelected.find(k=>k.doc==label.ContentType)}
                                      onChange={(e) => {
                                        
                                      let newdata = [ ...documentSelected ];
                                      if(e.target.checked){
                                        newdata.push({ doc: e.target.value,rq:false });
                                      }else{
                                        newdata = newdata.filter(l=>l.doc!=e.target.value)
                                      }

                                      setDocumentSelected(newdata)
                                      }}
                                    />
                                  }
                                  label={label.ContentType}
                                />
                              ))}
                        </FormGroup>
                        </div> */}
                            </div>

                            {/* <div class="position-relative pt-2 mb-2" >
                          <Typography className="flex w-full justify-center py-8 bg-gray-200 text-gray-600  ">
                               Document Required For Submission
                          </Typography>
                          <div class="border p-1">
                              <FormGroup  >
                              { 
                                documentOptions.map((label, index) => (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      value={label.ContentType}
                                      disabled = {!documentSelected.find(l => l.doc==label.ContentType)}
                                      checked={documentSelected.find(k=>k.doc==label.ContentType && k.rq==true)}

                                      onChange={(e) => {
                                      let newdata = [ ...documentSelected ];
                                      let findx  = newdata.findIndex((l)=>l.doc==e.target.value)
                                      if(e.target.checked){
                                        newdata[findx]['rq'] = true;
                                      }else{
                                        newdata[findx]['rq'] = false;
                                      }
                                      setDocumentSelected(newdata)
                                      }}
                                    />
                                  }
                                  label={label.ContentType}
                                />
                              ))}
                        </FormGroup>
                        </div>
                      </div>  */}
                          </Col>
                        </Row>
                        {/* end of document selection */}
                        <Row className="mt-2 mb-1">
                          <Col md={12}>
                            {jobOptionsList.length ?
                              <InterestSelection labelName='Add Job Role Interest' selected={tags}
                                setSelected={(selectedValues) => {
                                  setTags(selectedValues);
                                  setSelectedPostionNo(selectedValues);
                                }}
                                options={jobOptionsList}></InterestSelection>
                              : null}
                          </Col>
                        </Row>
                        <Row className="mt-2 mb-1">
                          <Col md={12}>
                            {jobOptionsCatList.length ?
                              <InterestSelection
                                labelName='Add Job Category Interest'
                                selectionMode='category'
                                setSelected={setCatTags}
                                selected={catTags}
                                options={jobOptionsCatList}
                              ></InterestSelection>
                              : null}
                          </Col>
                        </Row>

                        {/* <Col md={12}>
                          {renderDropDown(
                            "WhoCanApply",
                            "Who Can Apply",
                            WhoCanApplyOptions,
                            false
                          )}
                        </Col> */}



                        <Col md={12}>
                          {renderTextArea(
                            "QualificationRequirement",
                            "Qualification Requirements",
                            true,
                            false,
                            jaRegistryDisabledFields.has("QualificationRequirement")
                          )}
                        </Col>
                        <Col md={12}>
                          {renderTextArea(
                            "NecessarySpecialQualifications",
                            "Necessary Special Qualification",
                            true,
                            false,
                            jaRegistryDisabledFields.has("NecessarySpecialQualifications")
                          )}
                        </Col>
                        <Col md={12}>
                          {renderTextArea(
                            "NatureofWork",
                            "Nature of Work",
                            true,
                            false,
                            jaRegistryDisabledFields.has("NatureofWork")
                          )}
                        </Col>
                        <Col md={12}>
                          {renderTextArea(
                            "illustrativeExofWork",
                            "Illustrative Example of Work",
                            true,
                            false,
                            jaRegistryDisabledFields.has("illustrativeExofWork")
                          )}
                        </Col>
                        <Col md={12}>
                          {renderTextArea(
                            "KnowledgeAbilitiesSkills",
                            "Knowledge , Abilities & Skills",
                            true,
                            false,
                            jaRegistryDisabledFields.has("KnowledgeAbilitiesSkills")
                          )}
                        </Col>
                        <Col md={12}>
                          {renderTextArea(
                            "MinimumEducationReq",
                            "Minimum Educational Requirements",
                            true,
                            false,
                            jaRegistryDisabledFields.has("MinimumEducationReq")
                          )}
                        </Col>
                      </Row>
                    </fieldset>
                    {/* Editable in every process status (Draft, QA, Appointing Authority, Posted, Closed), regardless of role */}
                    <Row>
                      <Col md={12}>
                        {renderTextArea(
                          "DocRequirement",
                          "Documentation Requirements",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "SuitabilityDeterminationForm",
                          "Suitability Determination Form",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "ProhibitionPursuant",
                          "Prohibition Pursuant to P.L.28-98",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "InterviewProcedures",
                          "Interviewing Procedures",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      {/* <Col md={12}>
                          {renderTextArea(
                            "ExaminationReq",
                            "Examination Requirements",
                            true,
                            true,
                            jaRegistryDisabledFields.has("ExaminationReq")
                          )}
                        </Col> */}
                      <Col md={12}>
                        {renderTextArea(
                          "EmploymentMedicalExamination",
                          "Employment Medical Examination",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "WorkEligibility",
                          "Work Eligibility",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "DrugScreening",
                          "Drug Screening",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      <Col md={12}>
                        {renderTextArea(
                          "PoliceCourtClearances",
                          "Police & Court Clearances Requirements",
                          true,
                          false,
                          false
                        )}
                      </Col>
                      {/* <Col md={12}>
                          {renderTextArea(
                            "WhereToApply",
                            "Where to Apply",
                            true,
                            true,
                            jaRegistryDisabledFields.has("WhereToApply")
                          )}
                        </Col> */}

                      <Col md={12}>
                        {renderTextArea(
                          "ForMoreInfo",
                          "For More Information",
                          true,
                          false,
                          false
                        )}
                      </Col>
                    </Row>
                    {/* <Card className="p-3 my-3" elevation={1}>
                      <CardBody>
                        <Col xs={12} lg={4} md={4} sm={12}>
                          <Typography variant="h6">
                            <FontAwesomeIcon
                              className="m-r-10 font-primary"
                              icon={faCircleInfo}
                              size="lg"
                            />
                            Audit Trail

                            <Btn
                              attrBtn={{
                                color: "primary",
                                onClick: () => {
                                  setAuditTrailModalOpen(true);
                                },
                                style: {
                                  marginLeft: "6px",
                                },
                              }}
                            >
                              Columns History
                            </Btn>

                            <Btn
                              attrBtn={{
                                color: "primary",
                                onClick: () => {
                                  openFieldHistoryModal();
                                },
                                style: {
                                  marginLeft: "6px",
                                },
                              }}
                            >
                              History
                            </Btn>

                          </Typography>
                        </Col>

                        <TableContainer
                          style={{ marginBottom: "15px" }}
                          component={Paper}
                        >
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Sr No</TableCell>
                                <TableCell>Performed Date</TableCell>
                                <TableCell>Process</TableCell>
                                <TableCell>Performed by</TableCell>
                                <TableCell>Remark</TableCell>
                                <TableCell>Status</TableCell>
                              </TableRow>
                            </TableHead>


                            <TableBody>
                              {jobTransactionLogLoading ? (
                                <TableRow>
                                  <TableCell colSpan={6} align="center">
                                    Loading...
                                  </TableCell>
                                </TableRow>
                              ) : jobTransactionLogData?.length ? (
                                jobTransactionLogData.map((row, index) => (
                                  <TableRow key={row?.id ?? index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                      {row?.performedDate
                                        ? moment(row.performedDate).format("MM/DD/YYYY hh:mm A")
                                        : ""}
                                    </TableCell>
                                    <TableCell>{row?.actionType == "Approved" ? "Forwarded" : row?.actionType}</TableCell>
                                    <TableCell>{row?.transactionText}</TableCell>
                                    <TableCell>{row?.remarks}</TableCell>
                                    <TableCell>{row?.performedByName}</TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={6} align="center">
                                    No records found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardBody>
                    </Card> */}
                    <Dialog
                      open={fieldHistoryModalOpen}
                      onClose={() => setFieldHistoryModalOpen(false)}
                      maxWidth="lg"
                      fullWidth
                    >
                      <DialogTitle>
                        Documentation Fields History
                        <Btn
                          attrBtn={{
                            color: "primary",
                            onClick: () => {
                              openHistoryDiffModal();
                            },
                            style: {
                              marginLeft: "6px",
                            },
                          }}
                        >
                          View Differences
                        </Btn>
                      </DialogTitle>
                      <DialogContent>
                        <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 650 }} aria-label="field history table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Field Name</TableCell>
                                <TableCell sx={{ minWidth: 250 }}>Old Value</TableCell>
                                <TableCell>New Value</TableCell>
                                <TableCell sx={{ minWidth: 180 }}>Performed By</TableCell>
                                <TableCell>Date</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {fieldHistoryLoading ? (
                                <TableRow>
                                  <TableCell colSpan={5} align="center">
                                    Loading...
                                  </TableCell>
                                </TableRow>
                              ) : fieldHistoryData?.length ? (
                                fieldHistoryData.map((row, index) => (
                                  <TableRow key={row?.ID || index}>
                                    <TableCell>
                                      {documentationFieldLabels[row?.FIELD_NAME?.trim()] ||
                                        row?.FIELD_NAME}
                                    </TableCell>
                                    <TableCell>{row?.OLD_VALUE}</TableCell>
                                    <TableCell>{row?.NEW_VALUE}</TableCell>
                                    <TableCell>{row?.PERFORMED_BY}</TableCell>
                                    <TableCell>
                                      {row?.DATE_STARTED
                                        ? moment(row.DATE_STARTED).format(
                                          "MM/DD/YYYY hh:mm A"
                                        )
                                        : ""}
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={5} align="center">
                                    No records found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setFieldHistoryModalOpen(false)}>
                          Close
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <DifferencesModal
                      visible={historyDiffModalOpen}
                      setVisible={setHistoryDiffModalOpen}
                      data={historyDiffData}
                      loading={auditTrailLoading}
                      loadingPanel={loadingPanel}
                    />
                    <Dialog
                      open={auditTrailModalOpen}
                      onClose={() => setAuditTrailModalOpen(false)}
                      maxWidth="lg"
                      fullWidth
                    >
                      <DialogTitle>Columns History</DialogTitle>
                      <DialogContent>
                        <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 850 }} aria-label="columns history table">
                            <TableHead>
                              <TableRow>
                                <TableCell>Field Name</TableCell>
                                <TableCell sx={{ minWidth: 250 }}>Old Value</TableCell>
                                <TableCell>New Value</TableCell>
                                <TableCell sx={{ minWidth: 180 }}>Performed By</TableCell>
                                <TableCell>Date</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {auditTrailLoading ? (
                                <TableRow>
                                  <TableCell colSpan={5} align="center">
                                    Loading...
                                  </TableCell>
                                </TableRow>
                              ) : columnsHistoryRows?.length ? (
                                columnsHistoryRows.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell>{row.field}</TableCell>
                                    <TableCell>{row.oldValue}</TableCell>
                                    <TableCell>{row.newValue}</TableCell>
                                    <TableCell>{row.performedBy}</TableCell>
                                    <TableCell>
                                      {row.date
                                        ? moment(row.date).format(
                                          "MM/DD/YYYY hh:mm A"
                                        )
                                        : ""}
                                    </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={5} align="center">
                                    No records found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setAuditTrailModalOpen(false)}>
                          Close
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </Form>
      <div style={{ display: "none" }}>
        <ComponentToPrint
          ref={componentRef}
          // data={values}
          data={values}
          title={jobTypeOptionsList.find(item => (item.AreaOfConsidration || item.areaOfConsidration) === values.announcementType)?.AreaOfConsidration}
          title2={jobTypeOptionsList.find(item => (item.AreaOfConsidration || item.areaOfConsidration) === values.secondaryAnnouncementType)?.AreaOfConsidration}
          status={values?.AnnouncementStatus}
          selectivefactor={isChecked}
        />
      </div>
    </Fragment >
  );
}

// Simplified version of ReqCombinedTabs without left tabs
const ReqCombinedTabsSimplified = React.forwardRef(({ supplementalData = [] }, ref) => {

  const [sections] = useState(['Education', 'Skill', 'Certification', 'Specialization']);
  const [tabQuestions, setTabQuestions] = useState({});
  const [deletedSupplementalIds, setDeletedSupplementalIds] = useState([]);

  // Populate tabQuestions from supplementalData on mount
  useEffect(() => {
    if (supplementalData.length > 0) {
      const groupedData = {};
      supplementalData.forEach((item, index) => {
        const section = item.reqType;
        if (!groupedData[section]) {
          groupedData[section] = [];
        }
        groupedData[section].push({
          id: index,
          question: item.description,
          answerType: item.answerType,
          weight: item.defaultWeight || '',
          supplementalReqId: item.supplementalReqId,
          isExisting: true
        });
      });
      setTabQuestions(groupedData);
    }
  }, [supplementalData]);

  const getQuestions = (section) => {
    return tabQuestions[section] || [{ id: 0, question: '', answerType: 'yes-no', weight: '' }];
  };

  // Ensure at least one default row exists
  useEffect(() => {
    if (Object.keys(tabQuestions).length === 0) {
      setTabQuestions({ 'Education': [{ id: 0, question: '', answerType: 'yes-no', weight: '' }] });
    }
  }, []);

  const setQuestions = (section, questions) => {
    setTabQuestions(prev => ({ ...prev, [section]: questions }));
  };

  const addQuestion = (section) => {
    const currentQuestions = getQuestions(section);
    // Date.now() hamesha sabse bada number dega, toh row hamesha niche aayegi
    const newQuestions = [...currentQuestions, { id: Date.now(), question: '', answerType: 'yes-no', weight: '' }];
    setQuestions(section, newQuestions);
  };

  const updateQuestion = (section, id, field, value) => {
    const currentQuestions = getQuestions(section);
    const updatedQuestions = currentQuestions.map(q => q.id === id ? { ...q, [field]: value } : q);
    setQuestions(section, updatedQuestions);
  };

  const removeQuestion = (section, id) => {
    const currentQuestions = getQuestions(section);
    if (currentQuestions.length > 1) {
      const filteredQuestions = currentQuestions.filter(q => q.id !== id);
      setQuestions(section, filteredQuestions);
    }
  };

  // Expose getTabQuestions and deletedSupplementalIds via ref
  React.useImperativeHandle(ref, () => ({
    getTabQuestions: () => {
      const filteredQuestions = {};
      Object.keys(tabQuestions).forEach(section => {
        const validQuestions = tabQuestions[section].filter(q => q.question && q.question.trim() !== '');
        if (validQuestions.length > 0) {
          filteredQuestions[section] = validQuestions;
        }
      });
      return filteredQuestions;
    },
    getDeletedSupplementalIds: () => deletedSupplementalIds
  }));

  // Get all questions from all sections
  const getAllQuestions = () => {
    const allQuestions = [];
    sections.forEach(section => {
      const sectionQuestions = tabQuestions[section] || [];
      sectionQuestions.forEach(q => {
        allQuestions.push({ ...q, section });
      });
    });
    // Sort hata den taaki naya question array ke end mein hi dikhe
    // Ya fir agar ID se hi karna hai toh ensure karein maxId sahi hai
    return allQuestions;
  };

  const updateQuestionInSection = (questionId, section, field, value) => {
    const currentQuestions = getQuestions(section);
    const updatedQuestions = currentQuestions.map(q => q.id === questionId ? { ...q, [field]: value } : q);
    setQuestions(section, updatedQuestions);
  };

  const removeQuestionFromSection = (questionId, section) => {
    const currentQuestions = getQuestions(section);

    const totalQuestionsCount = Object.values(tabQuestions).reduce((acc, curr) => acc + curr.length, 0);

    if (totalQuestionsCount > 1) {
      const questionToDelete = currentQuestions.find(q => q.id === questionId);
      if (questionToDelete && questionToDelete.supplementalReqId) {
        setDeletedSupplementalIds(prev => [...prev, questionToDelete.supplementalReqId]);
      }
      const filteredQuestions = currentQuestions.filter(q => q.id !== questionId);
      setQuestions(section, filteredQuestions);
    } else {
      alert("At least one question is required.");
    }
  };

  const allQuestions = getAllQuestions();

  return (
    <Box sx={{ border: '1px solid #ddd', padding: 2, borderRadius: 1, width: '100%', background: '#fff6e6' }}>
      {allQuestions.map((q, index) => (
        <Box key={`${q.section}-${q.id}`} sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1, width: '100%' }}>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Select Section</InputLabel>
            <Select
              value={q.section}
              onChange={(e) => {
                // Move question to new section without deleting
                const oldSection = q.section;
                const newSection = e.target.value;

                // Remove from old section without tracking as deleted
                const oldQuestions = getQuestions(oldSection);
                const filteredOldQuestions = oldQuestions.filter(question => question.id !== q.id);
                setQuestions(oldSection, filteredOldQuestions);

                // Add to new section
                const newQuestions = getQuestions(newSection);
                setQuestions(newSection, [...newQuestions, { ...q, section: newSection }]);
              }}
              label="Select Section"
            >
              {sections.map((section) => (
                <MenuItem key={section} value={section}>{section}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label={`Question ${index + 1}`}
            variant="outlined"
            size="small"
            sx={{ flex: 1 }}
            value={q.question}
            onChange={(e) => updateQuestionInSection(q.id, q.section, 'question', e.target.value)}
            placeholder="Enter your question here..."
          />
          <TextField
            label="Weight"
            variant="outlined"
            size="small"
            type="number"
            sx={{ width: 120 }}
            value={q.weight || ''}
            onChange={(e) => updateQuestionInSection(q.id, q.section, 'weight', e.target.value)}
            inputProps={{ min: 1 }}
          />
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Answer Type</InputLabel>
            <Select
              value={q.answerType}
              onChange={(e) => updateQuestionInSection(q.id, q.section, 'answerType', e.target.value)}
              label="Answer Type"
            >
              <MenuItem value="yes-no">Yes/No</MenuItem>
              <MenuItem value="input">Input</MenuItem>
            </Select>
          </FormControl>
          {allQuestions.length > 1 && (
            <IconButton
              size="small"
              onClick={() => removeQuestionFromSection(q.id, q.section)}
              color="error"
            >
              <Icon name="trash" />
            </IconButton>
          )}
        </Box>
      ))}
      <Button onClick={() => addQuestion('Education')} variant="outlined" size="small" sx={{ mt: 1 }}>
        + Add Question
      </Button>
    </Box>
  );
});

export default JobAnnouncementNew;
